import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

// This list is often updated from the spreadsheet here:
// https://www.educationcounts.govt.nz/data-services/code-sets-and-classifications/school_name_and_number_codes
// When you do - ensure you keep 998 - Unknown and 999 - Overseas School

export default BaseEnum.create({
  values: [
    { value: '998', label: 'Unknown' },
    { value: '999', label: 'Overseas School' },
    { value: '1', label: 'Te Kura o Te Kao (1)' },
    { value: '2', label: 'Taipa Area School (2)' },
    { value: '3', label: 'Kaitaia College (3)' },
    { value: '4', label: 'Whangaroa College (4)' },
    { value: '5', label: 'Kerikeri High School (5)' },
    { value: '6', label: 'Broadwood Area School (6)' },
    { value: '7', label: 'Okaihau College (7)' },
    { value: '8', label: 'Bay of Islands College (8)' },
    { value: '9', label: 'Northland College (9)' },
    { value: '10', label: 'Te Kura Taumata o Panguru (10)' },
    { value: '11', label: 'Opononi Area School (11)' },
    { value: '12', label: 'Tauraroa Area School (12)' },
    { value: '13', label: 'Te Kamo High School (13)' },
    { value: '14', label: 'Tikipunga High School (14)' },
    { value: '15', label: "Whangārei Boys' High School (15)" },
    { value: '16', label: "Whangārei Girls' High School (16)" },
    { value: '17', label: 'Pompallier Catholic College (17)' },
    { value: '18', label: 'Mangakahia Area School (18)' },
    { value: '19', label: 'Dargaville High School (19)' },
    { value: '20', label: 'Bream Bay College (20)' },
    { value: '21', label: 'Otamatea High School (21)' },
    { value: '22', label: 'Ruawai College (22)' },
    { value: '23', label: 'Rodney College (23)' },
    { value: '24', label: 'Mahurangi College (24)' },
    { value: '25', label: 'Orewa College (25)' },
    { value: '26', label: 'Kaipara College (26)' },
    { value: '27', label: 'Long Bay College (27)' },
    { value: '28', label: 'Rangitoto College (28)' },
    { value: '29', label: 'Kristin School (29)' },
    { value: '30', label: 'Glenfield College (30)' },
    { value: '31', label: 'Birkenhead College (31)' },
    { value: '32', label: 'Northcote College (32)' },
    { value: '35', label: 'Carmel College (35)' },
    { value: '36', label: 'Takapuna Grammar School (36)' },
    { value: '37', label: "Westlake Boys' High School (37)" },
    { value: '38', label: "Westlake Girls' High School (38)" },
    { value: '39', label: 'Rosmini College (39)' },
    { value: '40', label: 'Rutherford College (40)' },
    { value: '41', label: 'Macleans College (41)' },
    { value: '42', label: 'Green Bay High School (42)' },
    { value: '43', label: 'Massey High School (43)' },
    { value: '44', label: 'Waitakere College (44)' },
    { value: '45', label: 'Henderson High School (45)' },
    { value: '46', label: 'Liston College (46)' },
    { value: '47', label: "St Dominic's Catholic College (Henderson) (47)" },
    { value: '48', label: 'Western Springs College-Ngā Puna o Waiōrea (48)' },
    { value: '49', label: 'Selwyn College (49)' },
    { value: '50', label: "St Mary's College (Ponsonby) (50)" },
    { value: '51', label: "St Paul's College (Ponsonby) (51)" },
    { value: '52', label: 'Tyndale Park Christian School (52)' },
    { value: '53', label: "Auckland Girls' Grammar School (53)" },
    { value: '54', label: 'Auckland Grammar School (54)' },
    { value: '57', label: 'Tamaki College (57)' },
    { value: '58', label: 'Tangaroa College (58)' },
    { value: '59', label: 'Sacred Heart College (Auckland) (59)' },
    { value: '60', label: "Saint Kentigern Girls' School (60)" },
    { value: '61', label: 'Baradene College (61)' },
    { value: '62', label: "St Peter's College (Epsom) (62)" },
    { value: '63', label: 'Marcellin College (63)' },
    { value: '64', label: 'Epsom Girls Grammar School (64)' },
    { value: '65', label: 'Glendowie College (65)' },
    { value: '66', label: 'Dilworth School (66)' },
    { value: '67', label: 'Diocesan School For Girls (67)' },
    { value: '68', label: "St Cuthbert's College (Epsom) (68)" },
    { value: '69', label: 'Mt Albert Grammar School (69)' },
    { value: '70', label: 'Marist College (70)' },
    { value: '74', label: 'Mt Roskill Grammar (74)' },
    { value: '75', label: 'Lynfield College (75)' },
    { value: '77', label: 'Bethlehem College (77)' },
    { value: '78', label: 'Avondale College (78)' },
    { value: '79', label: 'Edgewater College (79)' },
    { value: '80', label: 'Pakuranga College (80)' },
    { value: '81', label: 'Saint Kentigern College (81)' },
    { value: '82', label: 'Aidanfield Christian School (82)' },
    { value: '83', label: "Kelston Boys' High School (83)" },
    { value: '84', label: "Kelston Girls' College (84)" },
    { value: '85', label: 'One Tree Hill College (85)' },
    { value: '86', label: 'Onehunga High School (86)' },
    { value: '87', label: 'Howick College (87)' },
    { value: '88', label: 'Otahuhu College (88)' },
    { value: '89', label: "King's College (89)" },
    { value: '90', label: 'McAuley High School (90)' },
    { value: '91', label: 'Mangere College (91)' },
    { value: '93', label: 'Auckland Seventh-Day Adventist H S (93)' },
    { value: '94', label: 'De La Salle College (94)' },
    { value: '95', label: 'Papatoetoe High School (95)' },
    { value: '96', label: 'Aorere College (96)' },
    { value: '97', label: 'Sir Edmund Hillary Collegiate Senior School (97)' },
    { value: '99', label: 'Manurewa High School (99)' },
    { value: '100', label: 'James Cook High School (100)' },
    { value: '101', label: 'Papakura High School (101)' },
    { value: '102', label: 'Rosehill College (102)' },
    { value: '103', label: 'Pukekohe High School (103)' },
    { value: '104', label: 'Wesley College (104)' },
    { value: '105', label: 'Waiuku College (105)' },
    { value: '106', label: 'Tuakau College (106)' },
    { value: '108', label: 'Onewhero Area School (108)' },
    { value: '109', label: 'Coromandel Area School (109)' },
    { value: '110', label: 'Mercury Bay Area School (110)' },
    { value: '111', label: 'Thames High School (111)' },
    { value: '112', label: 'Hauraki Plains College (112)' },
    { value: '113', label: 'Paeroa College (113)' },
    { value: '114', label: 'Waihi College (114)' },
    { value: '115', label: 'Te Kauwhata College (115)' },
    { value: '116', label: 'Te Aroha College (116)' },
    { value: '117', label: 'Katikati College (117)' },
    { value: '118', label: 'Mount Maunganui College (118)' },
    { value: '119', label: 'Huntly College (119)' },
    { value: '120', label: 'Ōtūmoetai College (120)' },
    { value: '121', label: "Tauranga Boys' College (121)" },
    { value: '122', label: "Tauranga Girls' College (122)" },
    { value: '123', label: 'Te Puke High School (123)' },
    { value: '124', label: 'Matamata College (124)' },
    { value: '125', label: 'Raglan Area School (125)' },
    { value: '126', label: 'Morrinsville College (126)' },
    { value: '127', label: 'Ngaruawahia High School (127)' },
    { value: '129', label: 'Fairfield College (129)' },
    { value: '130', label: "St Paul's Collegiate (Hamilton) (130)" },
    { value: '131', label: "Hamilton Boys' High School (131)" },
    { value: '132', label: "Hamilton Girls' High School (132)" },
    { value: '133', label: 'Raphael House Rudolf Steiner Area School (133)' },
    { value: '134', label: 'Flaxmere College (134)' },
    { value: '135', label: 'Fraser High School (135)' },
    { value: '136', label: "St John's College (Hillcrest) (136)" },
    { value: '138', label: 'Hillcrest High School (138)' },
    { value: '139', label: "Sacred Heart Girls' College (Ham) (139)" },
    { value: '140', label: 'Waikato Diocesan School For Girls (140)' },
    { value: '141', label: "St Peter's School (Cambridge) (141)" },
    { value: '142', label: 'Cambridge High School (142)' },
    { value: '143', label: 'Trident High School (143)' },
    { value: '144', label: 'Whakatane High School (144)' },
    {
      value: '145',
      label: 'Rangitaiki College – Te Kura Tuarua o Rangitaiki (145)',
    },
    { value: '146', label: 'Te Awamutu College (146)' },
    { value: '148', label: 'Opotiki College (148)' },
    { value: '151', label: 'Western Heights High School (151)' },
    { value: '152', label: "Rotorua Boys' High School (152)" },
    { value: '153', label: "Rotorua Girls' High School (153)" },
    { value: '154', label: 'Rotorua Lakes High School (154)' },
    { value: '157', label: 'Ōtorohanga College (157)' },
    { value: '158', label: 'Tokoroa High School (158)' },
    { value: '159', label: 'Forest View High School (159)' },
    { value: '160', label: 'Te Kuiti High School (160)' },
    { value: '161', label: 'Benneydale School (161)' },
    { value: '162', label: 'Piopio College (162)' },
    { value: '164', label: 'Reporoa College (164)' },
    { value: '166', label: 'Tauhara College (166)' },
    { value: '167', label: 'Taupo-nui-a-Tia College (167)' },
    { value: '169', label: 'Taumarunui High School (169)' },
    { value: '170', label: 'Waitara High School (170)' },
    { value: '171', label: "New Plymouth Boys' High School (171)" },
    { value: '172', label: "New Plymouth Girls' High School (172)" },
    { value: '173', label: 'Spotswood College (173)' },
    { value: '174', label: "Sacred Heart Girls' College (N Plymouth) (174)" },
    { value: '175', label: 'Francis Douglas Memorial College (175)' },
    { value: '176', label: 'Ohura Valley Primary (176)' },
    { value: '177', label: 'Inglewood High School (177)' },
    { value: '179', label: 'Stratford High School (179)' },
    { value: '180', label: 'Taranaki Diocesan School for Girls (180)' },
    { value: '181', label: 'Opunake High School (181)' },
    { value: '183', label: 'Ruapehu College (183)' },
    { value: '185', label: 'Patea Area School (185)' },
    { value: '187', label: 'Whanganui City College (187)' },
    { value: '188', label: "Whanganui Girls' College (188)" },
    { value: '189', label: 'Whanganui High School (189)' },
    { value: '190', label: 'Cullinane College (190)' },
    { value: '191', label: 'Longburn Adventist College (191)' },
    { value: '192', label: 'Whanganui Collegiate School (192)' },
    { value: '195', label: 'Rangitīkei College (195)' },
    { value: '196', label: 'Nga Tawa Diocesan School (196)' },
    { value: '197', label: 'Feilding High School (197)' },
    { value: '198', label: 'Awatapu College (198)' },
    { value: '199', label: 'Hato Paora College (199)' },
    { value: '200', label: 'Freyberg High School (200)' },
    { value: '201', label: 'Queen Elizabeth College (201)' },
    { value: '202', label: "Palmerston North Boys' High School (202)" },
    { value: '203', label: "Palmerston North Girls' High School (203)" },
    { value: '204', label: "St Peter's College (Palmerston North) (204)" },
    { value: '205', label: 'Manawatū College (205)' },
    { value: '206', label: 'Ngata Memorial College (206)' },
    { value: '208', label: 'Lytton High School (208)' },
    { value: '209', label: "Gisborne Boys' High School (209)" },
    { value: '210', label: "Gisborne Girls' High School (210)" },
    { value: '211', label: 'Campion College (211)' },
    { value: '212', label: 'Tolaga Bay Area School (212)' },
    { value: '214', label: 'Wairoa College (214)' },
    { value: '215', label: 'Taradale High School (215)' },
    { value: '216', label: "Napier Boys' High School (216)" },
    { value: '217', label: "Napier Girls' High School (217)" },
    { value: '218', label: 'Tamatea High School (218)' },
    { value: '219', label: 'Sacred Heart College (Napier) (219)' },
    { value: '220', label: 'William Colenso College (220)' },
    { value: '221', label: 'Te Wharekura o Ruatoki (221)' },
    { value: '222', label: "St Joseph's Maori Girls' College (222)" },
    { value: '223', label: 'Havelock North High School (223)' },
    { value: '224', label: 'Iona College (224)' },
    { value: '225', label: 'Woodford House (225)' },
    { value: '226', label: "St John's College (Hastings) (226)" },
    { value: '227', label: "Hastings Boys' High School (227)" },
    {
      value: '228',
      label: "Hastings Girls' High School – Ngā Rau Huia o Ākina (228)",
    },
    { value: '229', label: 'Karamū High School (229)' },
    { value: '230', label: 'Lindisfarne College (230)' },
    { value: '231', label: 'Taikura Rudolf Steiner School (231)' },
    { value: '232', label: 'Te Aute College (232)' },
    { value: '233', label: 'Central Hawkes Bay College (233)' },
    { value: '234', label: 'Dannevirke High School (234)' },
    { value: '235', label: 'Tararua College (235)' },
    { value: '236', label: 'Horowhenua College (236)' },
    { value: '237', label: 'Waiopehu College (237)' },
    { value: '240', label: 'Otaki College (240)' },
    { value: '241', label: 'Wairarapa College (241)' },
    { value: '242', label: 'Solway College (242)' },
    { value: '243', label: 'Mākoura College (243)' },
    { value: '244', label: 'Chanel College (244)' },
    { value: '245', label: 'Rathkeale College (245)' },
    { value: '246', label: "St Matthew's Collegiate (Masterton) (246)" },
    { value: '247', label: 'Kāpiti College (247)' },
    { value: '248', label: 'Paraparaumu College (248)' },
    { value: '249', label: 'Kuranui College (249)' },
    { value: '250', label: 'Upper Hutt College (250)' },
    { value: '251', label: 'Heretaunga College (251)' },
    { value: '252', label: "St Patrick's College (Silverstream) (252)" },
    { value: '253', label: 'Aotea College (253)' },
    { value: '254', label: 'Mana College (254)' },
    { value: '255', label: 'Porirua College (255)' },
    { value: '256', label: 'Bishop Viard College (256)' },
    { value: '257', label: 'Tawa College (257)' },
    { value: '258', label: 'Taita College (258)' },
    { value: '259', label: 'Naenae College (259)' },
    { value: '260', label: "St Bernard's College (260)" },
    { value: '261', label: 'Hutt Valley High School (261)' },
    { value: '262', label: 'Sacred Heart College (Lower Hutt) (262)' },
    { value: '263', label: 'Chilton Saint James School (263)' },
    { value: '265', label: "St Oran's College (265)" },
    { value: '266', label: 'Waipa Christian School (266)' },
    { value: '268', label: 'Newlands College (268)' },
    { value: '269', label: 'Onslow College (269)' },
    { value: '272', label: "Wellington Girls' College (272)" },
    { value: '273', label: 'Wellington High School and Com Ed Centre (273)' },
    { value: '274', label: "Wellington East Girls' College (274)" },
    { value: '275', label: 'Wellington College (275)' },
    { value: '276', label: "St Patrick's College (Kilbirnie) (276)" },
    { value: '277', label: 'Rongotai College (277)' },
    { value: '278', label: 'Queen Margaret College (278)' },
    { value: '279', label: 'TKKM o Hoani Waititi (279)' },
    { value: '280', label: 'Samuel Marsden Collegiate School (280)' },
    { value: '281', label: 'Scots College (281)' },
    { value: '282', label: 'Te Kura Amorangi o Whakawatea (282)' },
    { value: '283', label: 'Otamatea Christian School (283)' },
    { value: '284', label: 'St Catherines College (Kilbirnie) (284)' },
    { value: '286', label: "St Mary's College (Wellington) (286)" },
    { value: '287', label: 'Queen Charlotte College (287)' },
    { value: '288', label: "Marlborough Boys' College (288)" },
    { value: '289', label: "Marlborough Girls' College (289)" },
    { value: '290', label: 'Collingwood Area School (290)' },
    { value: '291', label: 'Rai Valley Area School (291)' },
    { value: '292', label: 'Golden Bay High School (292)' },
    { value: '293', label: 'Nayland College (293)' },
    { value: '294', label: 'Nelson College (294)' },
    { value: '295', label: 'Nelson College For Girls (295)' },
    { value: '296', label: 'Waimea College (296)' },
    { value: '297', label: 'Tapawera Area School (297)' },
    { value: '298', label: 'Motueka High School (298)' },
    { value: '299', label: 'Murchison Area School (299)' },
    { value: '300', label: 'Karamea Area School (300)' },
    { value: '301', label: 'Buller High School (301)' },
    { value: '303', label: 'Greymouth High School (303)' },
    { value: '304', label: 'John Paul II High School (304)' },
    { value: '305', label: 'Westland High School (305)' },
    { value: '306', label: 'South Westland Area School (306)' },
    { value: '307', label: 'Kaikōura High School (307)' },
    { value: '308', label: 'Amuri Area School (308)' },
    { value: '309', label: 'Cheviot Area School (309)' },
    { value: '310', label: 'Oxford Area School (310)' },
    { value: '311', label: 'Hurunui College (311)' },
    { value: '312', label: 'Rangiora High School (312)' },
    { value: '314', label: 'Kaiapoi High School (314)' },
    { value: '315', label: "St Bede's College (315)" },
    { value: '316', label: 'Papanui High School (316)' },
    { value: '317', label: 'Christchurch Adventist School (317)' },
    { value: '318', label: "St Andrew's College (Christchurch) (318)" },
    { value: '319', label: 'Burnside High School (319)' },
    { value: '320', label: 'Mairehau High School (320)' },
    {
      value: '321',
      label: "Shirley Boys' High School - Ngā Tama o Ōruapaeroa  (321)",
    },
    { value: '324', label: "Avonside Girls' High School (324)" },
    { value: '325', label: "Rangi Ruru Girls' School (325)" },
    { value: '326', label: 'Villa Maria College (326)' },
    { value: '327', label: "Christchurch Boys' High School (327)" },
    {
      value: '328',
      label: "Christchurch Girls' High School -Te Kura o Hine Waiora (328)",
    },
    { value: '329', label: 'Mangakino School (329)' },
    { value: '330', label: "Christ's College (330)" },
    { value: '331', label: 'St Thomas of Canterbury College (331)' },
    { value: '333', label: "St Margaret's College (333)" },
    { value: '334', label: 'Riccarton High School (334)' },
    { value: '335', label: 'Middleton Grange School (335)' },
    { value: '336', label: 'Te Puna Wai o Waipapa - Hagley College (336)' },
    { value: '337', label: 'Te Aratai College (337)' },
    { value: '338', label: 'Hornby High School (338)' },
    { value: '339', label: 'Hillmorton High School (339)' },
    { value: '340', label: 'Cashmere High School (340)' },
    { value: '341', label: 'Hillview Christian School (341)' },
    { value: '343', label: 'Marian College (343)' },
    { value: '344', label: 'Westminster Christian School (344)' },
    { value: '346', label: 'Darfield High School (346)' },
    { value: '347', label: 'Lincoln High School (347)' },
    { value: '348', label: 'Mount Hutt College (348)' },
    { value: '349', label: 'Ellesmere College (349)' },
    { value: '350', label: 'Akaroa Area School (350)' },
    { value: '351', label: 'Ashburton College (351)' },
    { value: '352', label: 'Geraldine High School (352)' },
    { value: '353', label: 'Mackenzie College (353)' },
    { value: '354', label: 'Opihi College (354)' },
    { value: '357', label: 'Craighead Diocesan School (357)' },
    { value: '358', label: 'Roncalli College (358)' },
    { value: '359', label: 'Mountainview High School (359)' },
    { value: '360', label: "Timaru Boys' High School (360)" },
    { value: '361', label: "Timaru Girls' High School (361)" },
    { value: '362', label: 'Waimate High School (362)' },
    { value: '363', label: 'Waitaki Valley School (363)' },
    { value: '365', label: "Waitaki Boys' High School (365)" },
    { value: '366', label: "Waitaki Girls' High School (366)" },
    { value: '368', label: 'The Cathedral Grammar School (368)' },
    { value: '369', label: 'St Kevins College (Oamaru) (369)' },
    { value: '370', label: 'Maniototo Area School (370)' },
    { value: '371', label: 'East Otago High School (371)' },
    { value: '372', label: 'Dunstan High School (372)' },
    { value: '373', label: 'Cromwell College (373)' },
    { value: '374', label: 'Wakatipu High School (374)' },
    { value: '375', label: 'Roxburgh Area School (375)' },
    { value: '376', label: 'Logan Park High School (376)' },
    { value: '377', label: "Otago Boys' High School (377)" },
    { value: '378', label: "Otago Girls' High School (378)" },
    { value: '380', label: 'St Hildas Collegiate (380)' },
    { value: '381', label: 'Kaikorai Valley College (381)' },
    { value: '382', label: 'Bayfield High School (382)' },
    { value: '383', label: 'Kings High School (Dunedin) (383)' },
    { value: '384', label: "Queen's High School (384)" },
    { value: '386', label: 'Columba College (386)' },
    { value: '387', label: 'John McGlashan College (387)' },
    { value: '390', label: 'Lawrence Area School (390)' },
    { value: '391', label: 'Blue Mountain College (391)' },
    { value: '392', label: 'Tokomairiro High School (392)' },
    { value: '393', label: 'South Otago High School (393)' },
    { value: '394', label: 'The Catlins Area School (394)' },
    { value: '395', label: 'Northern Southland College (395)' },
    { value: '397', label: "St Peter's College (Gore) (397)" },
    { value: '398', label: 'Takitimu Primary School (398)' },
    { value: '399', label: 'Central Southland College (399)' },
    { value: '400', label: 'Fiordland College (400)' },
    { value: '401', label: 'Menzies College (401)' },
    { value: '402', label: 'Waiau Area School (402)' },
    { value: '404', label: "Southland Boys' High School (404)" },
    { value: '405', label: "Southland Girls' High School (405)" },
    { value: '408', label: 'Verdon College (408)' },
    { value: '409', label: 'Aparima College (409)' },
    { value: '418', label: 'Rangiora New Life School (418)' },
    { value: '419', label: 'Rudolf Steiner School (Chch) (419)' },
    { value: '421', label: 'Richmond View School (421)' },
    { value: '422', label: 'Faith City School (422)' },
    { value: '424', label: 'Michael Park School (424)' },
    { value: '428', label: 'Whangamata Area School (428)' },
    { value: '429', label: 'Excellere College (429)' },
    { value: '432', label: 'KingsWay School (432)' },
    { value: '435', label: "Hukarere Girls' College (435)" },
    { value: '436', label: 'Springbank School (436)' },
    { value: '439', label: 'Totara College of Accelerated Learning (439)' },
    { value: '440', label: 'Pinehurst School (440)' },
    { value: '441', label: 'ACG Strathallan (441)' },
    { value: '443', label: 'Hastings Christian School (443)' },
    { value: '451', label: 'Hamilton Christian School (451)' },
    { value: '452', label: 'Southern Cross Campus (452)' },
    { value: '453', label: 'Kadimah School (453)' },
    { value: '454', label: "St Dominic's College (454)" },
    { value: '456', label: 'Pukekohe Christian School (456)' },
    { value: '460', label: 'Atea College (460)' },
    { value: '462', label: 'Ambury Park Centre (462)' },
    { value: '463', label: 'TKK Motuhake o Tawhiuau (463)' },
    { value: '465', label: 'Mana Tamariki (465)' },
    { value: '466', label: 'Manukau Christian School (466)' },
    { value: '471', label: 'Zayed College for Girls (471)' },
    { value: '472', label: 'OneSchool Global - New Zealand (472)' },
    { value: '476', label: 'Tongariro School (476)' },
    { value: '478', label: 'Wainuiomata High School (478)' },
    { value: '481', label: 'City Impact Church School (481)' },
    { value: '482', label: 'Aquinas College (482)' },
    { value: '484', label: 'Wentworth College (484)' },
    { value: '485', label: 'Taumata School (485)' },
    { value: '487', label: 'Mt Hobson Academy (487)' },
    { value: '488', label: 'Ngā Taiātea Wharekura (488)' },
    { value: '491', label: 'Sancta Maria College (491)' },
    { value: '494', label: 'Putāruru College (494)' },
    { value: '495', label: 'Taieri College (495)' },
    { value: '496', label: 'Reefton Area School (496)' },
    { value: '497', label: 'Te Kura o Hirangi (497)' },
    { value: '498', label: 'Te Aho o Te Kura Pounamu (498)' },
    { value: '506', label: 'Drury Christian School (506)' },
    { value: '514', label: 'Kimi Ora School (514)' },
    { value: '518', label: 'Kingslea School (518)' },
    { value: '522', label: 'Halswell Residential College (522)' },
    { value: '525', label: 'Salisbury School (Nelson) (525)' },
    { value: '527', label: 'Twizel Area School (527)' },
    { value: '528', label: 'Ponatahi Christian School (528)' },
    { value: '530', label: 'Waiheke High School (530)' },
    { value: '531', label: 'Catholic Cathedral College (531)' },
    { value: '532', label: 'John Paul College (532)' },
    { value: '533', label: 'Mt Aspiring College (533)' },
    { value: '536', label: 'Trinity Catholic College (536)' },
    { value: '539', label: 'Waikato Waldorf School ( Rudolf Steiner) (539)' },
    { value: '544', label: 'Al-Madinah School (544)' },
    { value: '545', label: 'Te Kura Toitu o Te Whaiti-nui-a-Toi (545)' },
    { value: '546', label: 'Whitby Collegiate (546)' },
    { value: '548', label: 'Aurora College (548)' },
    { value: '549', label: 'Taihape Area School (549)' },
    { value: '550', label: 'Te Waha O Rerekohu Area School (550)' },
    { value: '551', label: 'Coastal Taranaki School (551)' },
    { value: '552', label: 'James Hargest College (552)' },
    { value: '553', label: 'Mission Heights Junior College (553)' },
    { value: '554', label: 'Milns Road School (554)' },
    { value: '555', label: 'Tangaroa College Teen Parent Unit (555)' },
    { value: '557', label: 'Holy Family School (Wanaka) (557)' },
    { value: '558', label: 'TKKM o Te Kura Kokiri (558)' },
    { value: '559', label: 'Te Kura o Te Wainui-ā-Rua (559)' },
    { value: '563', label: 'Albany Senior High School (563)' },
    { value: '564', label: 'Ormiston Senior College (564)' },
    { value: '565', label: 'Stonefields School (565)' },
    { value: '566', label: 'Maraekakaho School (566)' },
    { value: '567', label: 'Te Wharekura o Te Kaokaoroa o Patetere (567)' },
    { value: '570', label: 'Mission Heights Primary School (570)' },
    { value: '571', label: 'ACG Sunderland (571)' },
    { value: '572', label: 'Te Matauru Primary (572)' },
    { value: '577', label: 'Te Totara Primary School (577)' },
    { value: '579', label: 'Knights Stream School- Mingimingi Hautoa (579)' },
    { value: '584', label: 'West Rolleston Primary School (584)' },
    { value: '585', label: 'Ararira Springs Primary- Te Puna o Ararira (585)' },
    { value: '586', label: 'Shotover Primary School (586)' },
    { value: '588', label: 'Hingaia Peninsula School (588)' },
    { value: '589', label: 'Te Kura o Nga Ruahine Rangi (589)' },
    { value: '593', label: 'Te Uho O Te Nikau Primary School (593)' },
    { value: '594', label: 'Te Kura Rau Iti (594)' },
    { value: '595', label: 'Kauri Flats School (595)' },
    { value: '600', label: 'TKKM o Ngaringaomatariki (600)' },
    { value: '601', label: 'Kumeroa School (601)' },
    { value: '603', label: 'KingsGate School (603)' },
    { value: '604', label: 'Golden Grove School (604)' },
    { value: '605', label: 'Wentworth Primary (605)' },
    { value: '607', label: 'Big Rock Primary School (607)' },
    { value: '608', label: 'Ashburton Christian School (608)' },
    {
      value: '612',
      label: 'Henderson - Teen Parent Unit - He Wero o nga Wahine (612)',
    },
    { value: '614', label: 'Amesbury School (614)' },
    { value: '615', label: 'Rototuna Senior High School (615)' },
    { value: '616', label: "Murihiku Young Parents' Learning Centre (616)" },
    { value: '618', label: 'Sancta Maria Catholic Primary School (618)' },
    { value: '620', label: 'Huanui College (620)' },
    { value: '622', label: 'Silverstream Christian School (622)' },
    { value: '624', label: 'Te Karaka Area School (624)' },
    { value: '625', label: 'Tamaoho School (625)' },
    { value: '628', label: 'TKKM o Tuia te Matangi (628)' },
    { value: '630', label: 'Te Kura Māori o Ngā Tapuwae (630)' },
    { value: '631', label: 'Kia Aroha Campus (631)' },
    { value: '632', label: 'Tai Wananga (632)' },
    { value: '633', label: 'Kingsview School (633)' },
    { value: '639', label: 'Pa Harakeke Teen Parent Unit (639)' },
    { value: '641', label: 'Te Wharekura o Nga Purapura o Te Aroha (641)' },
    { value: '647', label: 'Bathgate Park School (647)' },
    { value: '648', label: 'Carisbrook School (648)' },
    { value: '651', label: 'Te Whata Tau o Putauaki (651)' },
    { value: '654', label: 'Rolleston College (654)' },
    { value: '655', label: 'Kawerau Putauaki School (655)' },
    { value: '658', label: 'Murupara Area School (658)' },
    { value: '660', label: 'Kahurangi School (660)' },
    { value: '661', label: 'Tarawera High School (661)' },
    { value: '670', label: 'Nelson Teen Parent Unit (670)' },
    { value: '671', label: 'Waikato Montessori Education Centre (671)' },
    { value: '674', label: 'Levin Teen Parent Unit (674)' },
    { value: '682', label: 'Eden Christian Academy (682)' },
    { value: '683', label: 'Ao Tawhiti Unlimited Discovery (683)' },
    { value: '684', label: 'Te Waka Unua School (684)' },
    { value: '685', label: 'Waitākiri Primary School (685)' },
    { value: '686', label: 'Lyttelton Primary School (686)' },
    { value: '688', label: 'Ormiston Primary School (688)' },
    { value: '696', label: 'Rāwhiti School (696)' },
    { value: '704', label: 'Haeata Community Campus (704)' },
    { value: '705', label: 'Te Tipu Whenua o Pa Harakeke (705)' },
    { value: '706', label: 'Te Pā o Rākaihautū (706)' },
    { value: '707', label: 'ACG Tauranga (707)' },
    { value: '708', label: 'Rototuna Junior High School (708)' },
    { value: '709', label: 'Ormiston Junior College (709)' },
    { value: '710', label: 'Rolleston Christian School (710)' },
    { value: '712', label: 'Te Rōhutu Whio (712)' },
    { value: '717', label: 'Whakatane Teen Parent Unit (717)' },
    {
      value: '719',
      label: 'Te Kura Kaupapa Maori o Te Orini ki Ngati Awa (719)',
    },
    { value: '723', label: 'Massey-Redhills Primary School (723)' },
    { value: '724', label: 'Te Manawa ō Pāpāmoa School (724)' },
    { value: '725', label: 'Scott Point School (725)' },
    { value: '728', label: 'Meraki Montessori School (728)' },
    { value: '729', label: 'Northland College Teen Parent Unit (729)' },
    { value: '730', label: 'Porangahau School (730)' },
    { value: '737', label: 'Te Kura Kaupapa Maori o Horouta Wananga (737)' },
    { value: '738', label: 'St Francis of Assisi Catholic School (738)' },
    { value: '739', label: 'Manukura (739)' },
    { value: '742', label: 'Te Kura o Te Whānau-a-Apanui (742)' },
    { value: '743', label: 'Holy Trinity Catholic Primary School (743)' },
    { value: '746', label: 'Te Kura Whakatipu o Kawarau (746)' },
    { value: '747', label: 'Te Kura O Take Kārara (747)' },
    { value: '748', label: 'Ngākōroa School (748)' },
    { value: '752', label: 'Summit Point School (752)' },
    { value: '764', label: 'Ahutoetoe School (764)' },
    {
      value: '767',
      label: 'Nukumea Primary School - Te Kura Tuatahi O Nukumea (767)',
    },
    { value: '774', label: 'Matua Ngaru School (774)' },
    { value: '779', label: 'Fossil Bay School (779)' },
    { value: '780', label: 'Te Ao Mārama School (780)' },
    { value: '781', label: 'Jireh Christian School (781)' },
    { value: '787', label: 'Auckland Montessori College (787)' },
    { value: '840', label: 'Central Auckland Specialist School (840)' },
    { value: '846', label: 'Suzanne Aubert Catholic School (846)' },
    { value: '847', label: 'AGE School (847)' },
    { value: '854', label: 'Vanguard Military School (854)' },
    { value: '858', label: 'Cambridge West School (858)' },
    {
      value: '871',
      label: 'Te Rangihakahaka Centre for Science and Technology (871)',
    },
    { value: '872', label: 'Te Kōpuku High (872)' },
    { value: '873', label: 'Te Aratika Academy (873)' },
    { value: '874', label: 'Pacific Advance Secondary School (874)' },
    { value: '876', label: 'South Auckland Middle School (876)' },
    { value: '877', label: 'Middle School West Auckland (877)' },
    { value: '878', label: 'Te Wharekura o Ngāti Rongomai (878)' },
    { value: '879', label: 'Rise UP Academy (879)' },
    { value: '880', label: 'Waatea School (880)' },
    { value: '881', label: 'Tūranga Tangata Rite (881)' },
    { value: '900', label: 'A1 Student Arrowsmith School (900)' },
    { value: '902', label: 'Auckland Senior College (902)' },
    { value: '903', label: 'Ko Taku Reo - Deaf Education New Zealand (903)' },
    { value: '904', label: 'Green School New Zealand (904)' },
    { value: '921', label: 'Crimson Global Academy (921)' },
    { value: '932', label: 'Te Kura ā Iwi o Pawarenga (932)' },
    { value: '941', label: 'Iqra School (941)' },
    { value: '946', label: 'Motueka Steiner School (946)' },
    { value: '949', label: 'St Ignatius of Loyola Catholic College (949)' },
    { value: '955', label: 'Riverhead Primary #2 (955)' },
    { value: '956', label: 'Harvest Christian School (956)' },
    { value: '958', label: 'Liger Leadership Academy (958)' },
    { value: '959', label: 'Kumeu-Huapai Primary (959)' },
    { value: '960', label: 'TKKM o Tūtūtarakihi (960)' },
    { value: '961', label: 'Te Paepae o Aotea (961)' },
    { value: '962', label: 'Te Rau Horopito (962)' },
    { value: '972', label: 'Home Schooling (972)' },
    { value: '1000', label: 'Ahipara School (1000)' },
    { value: '1001', label: 'Aranga School (1001)' },
    { value: '1002', label: 'Arapohue School (1002)' },
    { value: '1004', label: 'Awanui School (1004)' },
    {
      value: '1007',
      label: 'Blomfield Special School and Resource Ctre (1007)',
    },
    { value: '1008', label: 'Dargaville Intermediate (1008)' },
    { value: '1009', label: 'Dargaville Primary School (1009)' },
    { value: '1011', label: 'Glenbervie School (1011)' },
    { value: '1013', label: 'Herekino School (1013)' },
    { value: '1014', label: 'Hikurangi School (1014)' },
    { value: '1015', label: 'Hora Hora School (Te Mai) (1015)' },
    { value: '1016', label: 'Horeke School (1016)' },
    { value: '1017', label: 'Hukerenui School Years 1-8 (1017)' },
    { value: '1018', label: 'Hurupaki School (1018)' },
    { value: '1019', label: 'Kaeo School (1019)' },
    { value: '1020', label: 'Kaihu Valley School (1020)' },
    { value: '1021', label: 'Kaikohe East School (1021)' },
    { value: '1022', label: 'Kaikohe Intermediate (1022)' },
    { value: '1023', label: 'Kaikohe West School (1023)' },
    { value: '1024', label: 'Kaingaroa School (Kaitaia) (1024)' },
    { value: '1025', label: 'Kaitaia Intermediate (1025)' },
    { value: '1026', label: 'Kaitaia School (1026)' },
    { value: '1027', label: 'Kaiwaka School (1027)' },
    { value: '1028', label: 'Totara Grove School (1028)' },
    { value: '1029', label: 'Te Kamo Intermediate School (1029)' },
    { value: '1030', label: 'Te Kamo School (1030)' },
    { value: '1031', label: 'Karetu School (1031)' },
    { value: '1032', label: 'Kaurihohore School (1032)' },
    { value: '1033', label: 'Kawakawa Primary School (1033)' },
    { value: '1034', label: 'Kerikeri Primary School (1034)' },
    { value: '1035', label: 'Kohukohu School (1035)' },
    { value: '1036', label: 'Kokopu School (1036)' },
    { value: '1037', label: 'Mangamuka School (1037)' },
    { value: '1038', label: 'Mangawhai Beach School (1038)' },
    { value: '1039', label: 'Mangonui School (1039)' },
    { value: '1042', label: 'Matakohe School (1042)' },
    { value: '1043', label: 'Matarau School (1043)' },
    { value: '1044', label: 'Matauri Bay School (1044)' },
    { value: '1046', label: 'Te Kura o Mātihetihe (1046)' },
    { value: '1047', label: 'Maungakaramea School (1047)' },
    { value: '1048', label: 'Maungatapere School (1048)' },
    { value: '1049', label: 'Maungaturoto School (1049)' },
    { value: '1050', label: 'Maunu School (1050)' },
    { value: '1052', label: 'Morningside School (1052)' },
    { value: '1053', label: 'Motatau School (1053)' },
    { value: '1055', label: 'Ngataki School (1055)' },
    { value: '1056', label: 'Ngunguru School (1056)' },
    { value: '1058', label: 'Ohaeawai School (1058)' },
    { value: '1059', label: 'Okaihau Primary School (1059)' },
    { value: '1060', label: 'Te Kura o Ōmanaia (1060)' },
    { value: '1061', label: 'One Tree Point School (1061)' },
    { value: '1062', label: 'Onerahi School (1062)' },
    { value: '1063', label: 'Opua School (1063)' },
    { value: '1065', label: 'Oromahoe School (1065)' },
    { value: '1066', label: 'Oruaiti School (1066)' },
    { value: '1068', label: 'Otaika Valley School (1068)' },
    { value: '1069', label: 'Te Kura o Otangarei (1069)' },
    { value: '1071', label: 'Oturu School (1071)' },
    { value: '1072', label: 'Paihia School (1072)' },
    { value: '1073', label: 'Pakaraka School (1073)' },
    { value: '1074', label: 'Pakiri School (1074)' },
    { value: '1075', label: 'Pakotai School (1075)' },
    { value: '1076', label: 'Pamapuria School (1076)' },
    { value: '1077', label: 'Paparoa School (1077)' },
    { value: '1078', label: 'Paparore School (1078)' },
    { value: '1080', label: 'Parua Bay School (1080)' },
    { value: '1081', label: 'Peria School (1081)' },
    { value: '1082', label: 'Pompallier Catholic School (1082)' },
    { value: '1083', label: 'Poroti School (1083)' },
    { value: '1084', label: 'Portland School Te Kura o Tikorangi (1084)' },
    { value: '1085', label: 'Pouto School (1085)' },
    { value: '1086', label: 'Pukenui School (Kaitaia) (1086)' },
    { value: '1087', label: 'Pukepoto School (1087)' },
    { value: '1089', label: 'Purua School (1089)' },
    { value: '1092', label: 'Raurimu Avenue School (1092)' },
    { value: '1093', label: 'Rawene School (1093)' },
    { value: '1094', label: 'Ruakākā School (1094)' },
    { value: '1095', label: 'Ruawai Primary School (1095)' },
    { value: '1096', label: 'Russell School (Bay Of Islands) (1096)' },
    { value: '1097', label: 'Selwyn Park School (1097)' },
    { value: '1098', label: "St Joseph's Catholic School (Dargaville) (1098)" },
    { value: '1100', label: 'Te Kura o Hato Hohepa Te Kamura (1100)' },
    { value: '1104', label: 'Tangiteroria School (1104)' },
    { value: '1105', label: 'Tangowahine School (1105)' },
    { value: '1106', label: 'Tapora School (1106)' },
    { value: '1107', label: 'Tauhoa School (1107)' },
    { value: '1109', label: 'Te Hapua School (1109)' },
    { value: '1110', label: 'Te Horo School (Whangarei) (1110)' },
    { value: '1111', label: 'Te Kopuru School (1111)' },
    { value: '1112', label: 'Bay of Islands International Academy (1112)' },
    { value: '1113', label: 'Tikipunga Primary School (1113)' },
    { value: '1114', label: 'Tinopai School (1114)' },
    { value: '1115', label: 'Tomarata School (1115)' },
    { value: '1116', label: 'Totara North School (1116)' },
    { value: '1119', label: 'Umawera School (1119)' },
    { value: '1120', label: 'Waihārara School (1120)' },
    { value: '1122', label: 'Waima School (1122)' },
    { value: '1124', label: 'Waiotira School (1124)' },
    { value: '1125', label: 'Waipu School (1125)' },
    { value: '1126', label: 'Wellsford School (1126)' },
    { value: '1127', label: 'Whananaki School (1127)' },
    { value: '1128', label: 'Whangarei Heads School (1128)' },
    { value: '1129', label: 'Whangarei Intermediate (1129)' },
    { value: '1130', label: 'Whangarei School (1130)' },
    { value: '1131', label: 'Whau Valley School (1131)' },
    { value: '1138', label: 'Renew School (1138)' },
    { value: '1139', label: 'Lake Taupo Christian School (1139)' },
    { value: '1142', label: 'TKKM o Takapau (1142)' },
    { value: '1143', label: 'TKKM o Nga Mokopuna (1143)' },
    { value: '1147', label: 'Te Rangi Aniwaniwa (1147)' },
    { value: '1148', label: 'Nelson Christian Academy (1148)' },
    { value: '1149', label: 'Sonrise Christian School (1149)' },
    { value: '1151', label: 'TKKM o Te Puaha o Waikato (1151)' },
    { value: '1153', label: 'TKKM o Te Koutu (1153)' },
    { value: '1154', label: 'TKKM o Te Rawhiti Roa (1154)' },
    { value: '1156', label: 'Horizon School (1156)' },
    { value: '1164', label: 'Everglade School (1164)' },
    { value: '1165', label: 'TKKM o Ruamata (1165)' },
    { value: '1167', label: 'Wanaka Primary School (1167)' },
    { value: '1168', label: 'Emmanuel Christian School (1168)' },
    { value: '1169', label: 'Paeroa Christian School (1169)' },
    { value: '1170', label: 'Whakatane S D A School (1170)' },
    { value: '1172', label: 'Cornerstone Christian School (1172)' },
    { value: '1175', label: 'Kaikohe Christian School (1175)' },
    { value: '1177', label: 'Te Huruhi School (1177)' },
    { value: '1178', label: 'Tasman Bay Christian School (1178)' },
    { value: '1179', label: 'Maranatha Christian School (1179)' },
    { value: '1184', label: 'Hāwera Christian School (1184)' },
    { value: '1185', label: 'Matahui School (1185)' },
    { value: '1186', label: 'Matamata Christian School (1186)' },
    { value: '1187', label: 'Tauranga Waldorf School (1187)' },
    { value: '1189', label: 'Wā Ora Montessori (1189)' },
    { value: '1190', label: 'Elim Christian College (1190)' },
    { value: '1192', label: 'Dunedin Rudolf Steiner School (1192)' },
    { value: '1194', label: 'Red Beach School (1194)' },
    { value: '1195', label: 'Adventure School (1195)' },
    { value: '1200', label: 'Ahuroa School (1200)' },
    { value: '1201', label: 'Aka Aka School (1201)' },
    { value: '1202', label: 'Albany School (1202)' },
    { value: '1203', label: 'Alfriston School (1203)' },
    { value: '1204', label: 'Anchorage Park School (1204)' },
    { value: '1206', label: 'Arahoe School (1206)' },
    { value: '1207', label: 'Ararimu School (1207)' },
    { value: '1208', label: 'Ardmore School (1208)' },
    { value: '1209', label: 'Arohanui Special School (1209)' },
    { value: '1210', label: 'Northern Health School (1210)' },
    { value: '1211', label: 'Auckland Normal Intermediate (1211)' },
    { value: '1212', label: 'Avondale Intermediate (1212)' },
    { value: '1213', label: 'Avondale Primary School (Auckland) (1213)' },
    { value: '1214', label: 'Awhitu District School (1214)' },
    { value: '1215', label: 'Sir Douglas Bader Intermediate School (1215)' },
    { value: '1216', label: 'Bailey Road School (1216)' },
    {
      value: '1217',
      label: 'Sir Edmund Hillary Collegiate Middle School (1217)',
    },
    { value: '1218', label: 'Bairds Mainfreight Primary School (1218)' },
    { value: '1219', label: 'Balmoral School (Auckland) (1219)' },
    { value: '1220', label: 'Bayfield School (1220)' },
    { value: '1221', label: 'Bayswater School (1221)' },
    { value: '1222', label: 'Bayview School (1222)' },
    { value: '1223', label: 'Beach Haven School (1223)' },
    { value: '1224', label: 'Beachlands School (1224)' },
    { value: '1225', label: 'Belmont Intermediate (1225)' },
    { value: '1226', label: 'Belmont School (Auckland) (1226)' },
    { value: '1227', label: 'Birdwood School (1227)' },
    { value: '1228', label: 'Birkdale Intermediate (1228)' },
    { value: '1229', label: 'Birkdale North School (1229)' },
    { value: '1230', label: 'Birkdale Primary School (1230)' },
    { value: '1231', label: 'Birkenhead School (1231)' },
    { value: '1232', label: 'Blockhouse Bay Intermediate (1232)' },
    { value: '1233', label: 'Blockhouse Bay School (1233)' },
    { value: '1234', label: 'Bombay School (1234)' },
    { value: '1235', label: 'Botany Downs School (1235)' },
    { value: '1236', label: 'Brookby School (1236)' },
    { value: '1237', label: 'Browns Bay School (1237)' },
    { value: '1238', label: 'Bruce McLaren Intermediate (1238)' },
    { value: '1239', label: 'Buckland School (1239)' },
    { value: '1240', label: 'Bucklands Beach Intermediate (1240)' },
    { value: '1241', label: 'Bucklands Beach Primary School (1241)' },
    { value: '1242', label: 'Campbells Bay School (1242)' },
    { value: '1243', label: 'Chaucer School (1243)' },
    { value: '1244', label: 'Chelsea School (1244)' },
    {
      value: '1245',
      label: 'Christ the King Catholic School (Owairaka) (1245)',
    },
    { value: '1246', label: 'Churchill Park School (1246)' },
    { value: '1247', label: 'Clayton Park School (1247)' },
    { value: '1248', label: 'Clendon Park School (1248)' },
    { value: '1249', label: 'Clevedon School (1249)' },
    {
      value: '1251',
      label: 'Sir Edmund Hillary Collegiate Junior School (1251)',
    },
    { value: '1252', label: 'Coatesville School (1252)' },
    { value: '1253', label: 'Cockle Bay School (1253)' },
    { value: '1254', label: 'Colwill School Massey (1254)' },
    { value: '1255', label: 'Conifer Grove School (1255)' },
    { value: '1256', label: 'Cornwall Park District School (1256)' },
    { value: '1257', label: 'Cosgrove School (1257)' },
    { value: '1258', label: 'Dairy Flat School (1258)' },
    { value: '1259', label: 'Dawson School (1259)' },
    { value: '1260', label: 'Devonport Primary School (1260)' },
    { value: '1261', label: 'Dominion Road School (1261)' },
    { value: '1262', label: 'Don Buck School (1262)' },
    { value: '1263', label: 'Drury School (1263)' },
    { value: '1264', label: 'East Tamaki School (1264)' },
    { value: '1265', label: 'Edendale School (Auckland) (1265)' },
    { value: '1266', label: 'Edmonton School (1266)' },
    { value: '1267', label: 'Edmund Hillary School (1267)' },
    { value: '1268', label: 'Ellerslie School (1268)' },
    { value: '1269', label: 'Elm Park School (1269)' },
    { value: '1270', label: 'Epsom Normal School (1270)' },
    { value: '1271', label: 'Fairburn School (1271)' },
    { value: '1272', label: 'Farm Cove Intermediate (1272)' },
    { value: '1273', label: 'Favona School (1273)' },
    { value: '1274', label: 'Ferguson Intermediate (Otara) (1274)' },
    { value: '1275', label: 'Finlayson Park School (1275)' },
    { value: '1276', label: 'Flanshaw Road School (1276)' },
    { value: '1277', label: 'Flat Bush School (1277)' },
    { value: '1278', label: 'Forrest Hill School (1278)' },
    { value: '1279', label: 'Freemans Bay School (1279)' },
    { value: '1280', label: 'Freyberg Community School (1280)' },
    { value: '1281', label: 'Fruitvale Road School (1281)' },
    { value: '1282', label: 'Gladstone School (Auckland) (1282)' },
    { value: '1283', label: 'Glamorgan School (1283)' },
    { value: '1284', label: 'Glen Eden Intermediate (1284)' },
    { value: '1285', label: 'Glen Eden School (1285)' },
    { value: '1287', label: 'Glen Innes School (1287)' },
    { value: '1289', label: 'Glen Taylor School (1289)' },
    { value: '1290', label: 'Glenavon School (1290)' },
    { value: '1291', label: 'Glenbrae Primary School (1291)' },
    { value: '1292', label: 'Glenbrook School (1292)' },
    { value: '1293', label: 'Glendene School (1293)' },
    { value: '1294', label: 'Glendowie School (1294)' },
    { value: '1295', label: 'Glenfield Intermediate (1295)' },
    { value: '1296', label: 'Glenfield Primary School (1296)' },
    { value: '1297', label: 'Good Shepherd School (Balmoral) (1297)' },
    { value: '1298', label: 'Green Bay Primary School (1298)' },
    { value: '1299', label: 'Greenhithe School (1299)' },
    { value: '1300', label: 'Greenmeadows Intermediate (1300)' },
    { value: '1301', label: 'Grey Lynn School (1301)' },
    { value: '1302', label: 'Halsey Drive School (1302)' },
    { value: '1303', label: 'Harrisville School (1303)' },
    { value: '1304', label: 'Hauraki School (1304)' },
    { value: '1305', label: 'Hay Park School (1305)' },
    { value: '1306', label: 'Helensville School (1306)' },
    { value: '1307', label: 'Henderson Intermediate (1307)' },
    { value: '1308', label: 'Henderson North School (1308)' },
    { value: '1309', label: 'Henderson School (1309)' },
    { value: '1310', label: 'Henderson South School (1310)' },
    { value: '1311', label: 'Henderson Valley School (1311)' },
    { value: '1312', label: 'Hillpark School (1312)' },
    { value: '1313', label: 'Hillsborough School (1313)' },
    { value: '1314', label: 'Hobsonville School (1314)' },
    { value: '1315', label: 'Holy Cross School (Papatoetoe) (1315)' },
    { value: '1316', label: 'Holy Cross Catholic School (Henderson) (1316)' },
    { value: '1317', label: 'Homai School (1317)' },
    { value: '1318', label: 'Howick Intermediate (1318)' },
    { value: '1319', label: 'Howick Primary School (1319)' },
    { value: '1320', label: 'Huapai District School (1320)' },
    { value: '1321', label: 'Hunua School (1321)' },
    { value: '1322', label: 'Jean Batten School (1322)' },
    { value: '1323', label: 'Kaiaua School (1323)' },
    { value: '1324', label: 'Kaipara Flats School (1324)' },
    { value: '1325', label: 'Karaka School (1325)' },
    { value: '1326', label: 'Kaukapakapa School (1326)' },
    { value: '1327', label: 'Kauri Park School (1327)' },
    { value: '1328', label: 'Kaurilands School (1328)' },
    { value: '1329', label: 'Kedgley Intermediate (1329)' },
    { value: '1330', label: 'Kelston Intermediate (1330)' },
    { value: '1331', label: 'Kelston School (1331)' },
    { value: '1332', label: 'Kelvin Road School (1332)' },
    { value: '1333', label: 'Kingsford School (1333)' },
    { value: '1334', label: 'Kohimarama School (1334)' },
    { value: '1335', label: 'Konini School (Auckland) (1335)' },
    { value: '1336', label: 'Koru School (1336)' },
    { value: '1337', label: 'Kowhai Intermediate (1337)' },
    { value: '1338', label: 'Laingholm School (1338)' },
    { value: '1339', label: 'Leabank School (1339)' },
    { value: '1340', label: 'Leigh School (1340)' },
    { value: '1341', label: 'Lincoln Heights School (1341)' },
    { value: '1342', label: 'Long Bay School (1342)' },
    { value: '1343', label: 'Mairangi Bay School (1343)' },
    { value: '1344', label: 'Mangatangi School (1344)' },
    { value: '1345', label: 'Mangatawhiri School (1345)' },
    { value: '1346', label: 'Maangere Bridge School (1346)' },
    { value: '1347', label: 'Mangere Central School (1347)' },
    { value: '1348', label: 'Māngere East School (1348)' },
    { value: '1350', label: 'Manuka Primary School (1350)' },
    { value: '1351', label: 'Royal Oak Intermediate School (1351)' },
    { value: '1352', label: 'Manurewa East School (1352)' },
    { value: '1353', label: 'Manurewa Intermediate (1353)' },
    { value: '1354', label: 'Manurewa Central School (1354)' },
    { value: '1355', label: 'Manurewa South School (1355)' },
    { value: '1356', label: 'Manurewa West School (1356)' },
    { value: '1357', label: 'Maraetai Beach School (1357)' },
    { value: '1358', label: 'Maramarua School (1358)' },
    { value: '1359', label: 'Marist School (Mt Albert) (1359)' },
    { value: '1360', label: 'Marist Catholic School (Herne Bay) (1360)' },
    { value: '1361', label: 'Marlborough School (1361)' },
    { value: '1362', label: 'Marshall Laing School (1362)' },
    { value: '1363', label: 'Massey Primary School (1363)' },
    { value: '1364', label: 'Matakana School (1364)' },
    { value: '1365', label: 'Matipo Road School (1365)' },
    { value: '1366', label: 'Mauku School (1366)' },
    { value: '1367', label: 'Maungawhau School (1367)' },
    { value: '1368', label: 'May Road School (1368)' },
    { value: '1369', label: 'Mayfield School (Auckland) (1369)' },
    { value: '1370', label: 'Meadowbank School (1370)' },
    { value: '1371', label: 'Mellons Bay School (1371)' },
    { value: '1372', label: 'Te Paina School (1372)' },
    { value: '1373', label: 'Meremere School (1373)' },
    { value: '1375', label: 'Milford School (Auckland) (1375)' },
    { value: '1376', label: 'Monte Cecilia Catholic School (1376)' },
    { value: '1378', label: 'Mt Eden Normal School (1378)' },
    { value: '1379', label: 'Mt Richmond School (1379)' },
    { value: '1380', label: 'Mountain View School (1380)' },
    { value: '1381', label: 'Mt Albert School (1381)' },
    { value: '1382', label: 'Mt Carmel School (Meadowbank) (1382)' },
    { value: '1383', label: 'Mt Roskill Intermediate (1383)' },
    { value: '1384', label: 'Mt Roskill Primary School (1384)' },
    { value: '1385', label: 'Mulberry Grove School (1385)' },
    { value: '1386', label: 'Murrays Bay Intermediate (1386)' },
    { value: '1387', label: 'Murrays Bay School (1387)' },
    { value: '1388', label: 'Macleans Primary School (1388)' },
    { value: '1389', label: 'New Lynn School (1389)' },
    { value: '1390', label: 'New Windsor School (1390)' },
    { value: '1391', label: 'Newmarket School (1391)' },
    { value: '1392', label: 'Newton Central School (1392)' },
    { value: '1393', label: 'Nga Iwi School (1393)' },
    { value: '1394', label: 'Northcote Intermediate (1394)' },
    { value: '1395', label: 'Northcote School (Auckland) (1395)' },
    { value: '1396', label: 'Northcross Intermediate (1396)' },
    { value: '1397', label: 'Oaklynn Special School (1397)' },
    { value: '1398', label: 'Okiwi School (1398)' },
    { value: '1399', label: 'Onehunga Primary School (1399)' },
    { value: '1400', label: 'Onepoto School (1400)' },
    { value: '1401', label: 'Opaheke School (1401)' },
    { value: '1402', label: 'Orakei School (1402)' },
    { value: '1403', label: 'Oranga School (1403)' },
    { value: '1404', label: 'Oratia School (1404)' },
    { value: '1405', label: 'Orere School (1405)' },
    { value: '1406', label: 'Orewa Beach School (1406)' },
    { value: '1407', label: 'Orewa Primary School (1407)' },
    { value: '1408', label: 'Otahuhu Intermediate (1408)' },
    { value: '1409', label: 'Otahuhu School (1409)' },
    { value: '1410', label: 'Otaua School (1410)' },
    { value: '1411', label: 'Our Lady Sacred Heart School (Epsom) (1411)' },
    { value: '1412', label: 'Owairaka District School (1412)' },
    { value: '1413', label: 'Owairoa Primary School (1413)' },
    { value: '1414', label: 'Paerata School (1414)' },
    { value: '1416', label: 'Pakuranga Heights School (1416)' },
    { value: '1417', label: 'Pakuranga Intermediate (1417)' },
    { value: '1418', label: 'Panama Road School (1418)' },
    { value: '1419', label: 'Panmure Bridge School (1419)' },
    { value: '1420', label: 'Panmure District School (1420)' },
    { value: '1421', label: 'Papakura Central School (1421)' },
    { value: '1422', label: 'Papakura Intermediate (1422)' },
    { value: '1423', label: 'Papakura Normal School (1423)' },
    { value: '1424', label: 'Kereru Park Campus (1424)' },
    { value: '1425', label: 'Paparimu School (1425)' },
    { value: '1426', label: 'Papatoetoe Central School (1426)' },
    { value: '1427', label: 'Papatoetoe East School (1427)' },
    { value: '1428', label: 'Papatoetoe Intermediate (1428)' },
    { value: '1429', label: 'Papatoetoe North School (1429)' },
    { value: '1430', label: 'Papatoetoe South School (1430)' },
    { value: '1431', label: 'Papatoetoe West School (1431)' },
    { value: '1432', label: 'Parakai School (1432)' },
    { value: '1433', label: 'Ridgeview School (1433)' },
    { value: '1434', label: 'Mangapikopiko School (1434)' },
    { value: '1435', label: 'Parkside School (1435)' },
    { value: '1436', label: 'Parnell School (1436)' },
    { value: '1437', label: 'Pasadena Intermediate (1437)' },
    { value: '1438', label: 'Patumāhoe Primary School (1438)' },
    { value: '1439', label: 'Pigeon Mountain School (1439)' },
    { value: '1440', label: 'Point Chevalier School Rangi-mata-rau (1440)' },
    { value: '1441', label: 'Pt England School (1441)' },
    { value: '1442', label: 'Pokeno School (1442)' },
    { value: '1444', label: 'Pomaria Road School (1444)' },
    { value: '1445', label: 'Ponsonby Intermediate (1445)' },
    { value: '1446', label: 'Ponsonby Primary School (1446)' },
    { value: '1447', label: 'Prospect School (1447)' },
    { value: '1448', label: 'Puhinui School (1448)' },
    { value: '1449', label: 'Pukekawa School (1449)' },
    { value: '1450', label: 'Pukekohe East School (1450)' },
    { value: '1451', label: 'Pukekohe Hill School (1451)' },
    { value: '1452', label: 'Pukekohe Intermediate (1452)' },
    { value: '1453', label: 'Pukekohe North School (1453)' },
    { value: '1454', label: 'Pukeoware School (1454)' },
    { value: '1455', label: 'Puni School (1455)' },
    { value: '1456', label: 'Ramarama School (1456)' },
    { value: '1457', label: 'Rangeview Intermediate (1457)' },
    { value: '1458', label: 'Ranui School (1458)' },
    { value: '1459', label: 'Redhill School (1459)' },
    { value: '1460', label: 'Redoubt North School (1460)' },
    { value: '1461', label: 'Remuera Intermediate (1461)' },
    { value: '1462', label: 'Remuera School (1462)' },
    { value: '1463', label: 'Richmond Road School (1463)' },
    { value: '1464', label: 'Riverhead School (1464)' },
    { value: '1465', label: 'Riverhills School (1465)' },
    { value: '1466', label: 'Riverina School (1466)' },
    { value: '1467', label: 'Robertson Road School (1467)' },
    { value: '1468', label: 'Rongomai School (1468)' },
    { value: '1470', label: 'Roscommon School (1470)' },
    { value: '1471', label: 'Te Kura o Pātiki Rosebank School (1471)' },
    { value: '1472', label: 'Rosehill School (1472)' },
    { value: '1473', label: 'Rosehill Intermediate (1473)' },
    { value: '1474', label: 'Rowandale School (1474)' },
    { value: '1475', label: 'Royal Oak School (1475)' },
    { value: '1476', label: 'Royal Road School (1476)' },
    { value: '1477', label: 'Ruapotaka School (1477)' },
    { value: '1478', label: 'Rutherford School (1478)' },
    { value: '1479', label: 'Sandspit Road School (1479)' },
    { value: '1480', label: 'Shelly Park School (1480)' },
    { value: '1481', label: 'Sherwood School (Auckland) (1481)' },
    { value: '1482', label: 'Silverdale School (1482)' },
    { value: '1483', label: 'Sir Keith Park School (1483)' },
    { value: '1484', label: 'Sommerville School (1484)' },
    { value: '1486', label: "St Anne's Catholic School (Manurewa) (1486)" },
    {
      value: '1487',
      label: "St Dominic's Catholic School (Blockhouse Bay) (1487)",
    },
    {
      value: '1488',
      label: 'St Francis Catholic School (Pt Chevalier) (1488)',
    },
    { value: '1489', label: 'St Heliers School (1489)' },
    { value: '1490', label: 'St Ignatius Catholic School (St Heliers) (1490)' },
    { value: '1491', label: 'St John the Evangelist Catholic School (1491)' },
    { value: '1492', label: "St John's School (Mairangi Bay) (1492)" },
    { value: '1493', label: "St Joseph's School (Grey Lynn) (1493)" },
    { value: '1494', label: "St Joseph's Catholic School (Onehunga) (1494)" },
    { value: '1495', label: "St Joseph's School (Orakei) (1495)" },
    { value: '1496', label: "St Joseph's School (Otahuhu) (1496)" },
    { value: '1497', label: "St Joseph's School (Pukekohe) (1497)" },
    { value: '1498', label: "St Joseph's Catholic School (Takapuna) (1498)" },
    { value: '1499', label: 'St Leonards Road School (1499)' },
    { value: '1500', label: "St Leo's Catholic School (Devonport) (1500)" },
    { value: '1501', label: "St Mark's School (Pakuranga) (1501)" },
    { value: '1502', label: "St Mary's Catholic School (Papakura) (1502)" },
    { value: '1503', label: "St Mary's Catholic School (Avondale) (1503)" },
    { value: '1504', label: "St Mary's School (Ellerslie) (1504)" },
    { value: '1505', label: "St Mary's School (Northcote) (1505)" },
    { value: '1506', label: "St Michael's Catholic School (Remuera) (1506)" },
    { value: '1507', label: "St Patrick's School (Panmure) (1507)" },
    { value: '1508', label: 'St Pius X Catholic School (Glen Innes) (1508)' },
    { value: '1509', label: 'St Therese School (Three Kings) (1509)' },
    { value: '1510', label: 'St Thomas School (Auckland) (1510)' },
    { value: '1511', label: 'Stanhope Road School (1511)' },
    { value: '1512', label: 'Stanley Bay School (1512)' },
    { value: '1513', label: 'Stanmore Bay School (1513)' },
    { value: '1514', label: 'Our Lady Star of the Sea School (Howick) (1514)' },
    { value: '1515', label: 'Sunnyhills School (1515)' },
    { value: '1516', label: 'Sunnybrae Normal School (1516)' },
    { value: '1518', label: 'Sunnynook School (1518)' },
    { value: '1519', label: 'Sunnyvale School (1519)' },
    { value: '1520', label: 'Sutton Park School (1520)' },
    { value: '1521', label: 'Swanson School (1521)' },
    { value: '1522', label: 'Sylvia Park School (1522)' },
    { value: '1523', label: 'Takanini School (1523)' },
    { value: '1524', label: 'Takapuna Normal Intermediate (1524)' },
    { value: '1525', label: 'Takapuna School (1525)' },
    { value: '1526', label: 'Tāmaki School (1526)' },
    { value: '1528', label: 'Target Road School (1528)' },
    { value: '1529', label: 'Taupaki School (1529)' },
    { value: '1530', label: 'Te Atatu Intermediate (1530)' },
    { value: '1531', label: 'Peninsula Primary School (1531)' },
    { value: '1532', label: 'Te Hihi School (1532)' },
    { value: '1533', label: 'Te Kohanga School (1533)' },
    { value: '1534', label: 'Te Papapa School (1534)' },
    { value: '1535', label: 'Three Kings School (1535)' },
    { value: '1536', label: 'Tirimoana School (1536)' },
    { value: '1537', label: 'Titirangi School (1537)' },
    { value: '1538', label: 'Torbay School (1538)' },
    { value: '1539', label: 'Tuakau School (1539)' },
    { value: '1540', label: 'Valley School (1540)' },
    { value: '1541', label: 'Vauxhall School (1541)' },
    { value: '1543', label: 'Verran Primary School (1543)' },
    { value: '1544', label: 'Victoria Avenue School (1544)' },
    { value: '1545', label: 'View Road School (1545)' },
    { value: '1546', label: 'Viscount School (1546)' },
    { value: '1547', label: 'Waiau Pa School (1547)' },
    { value: '1548', label: 'Waikowhai Intermediate (1548)' },
    { value: '1549', label: 'Waikowhai Primary School (1549)' },
    { value: '1550', label: 'Waimauku School (1550)' },
    { value: '1552', label: 'Wainui School (1552)' },
    { value: '1553', label: 'Waioneke School (1553)' },
    { value: '1554', label: 'Waipipi School (1554)' },
    { value: '1555', label: 'Wairau Intermediate (1555)' },
    { value: '1556', label: 'Wairau Valley Special School (1556)' },
    { value: '1557', label: 'Waitakere School (1557)' },
    { value: '1558', label: 'Waitoki School (1558)' },
    { value: '1559', label: 'Waiuku Primary School (1559)' },
    { value: '1560', label: 'Wakaaranga School (1560)' },
    { value: '1561', label: 'Warkworth School (1561)' },
    { value: '1562', label: 'Waterlea Public School (1562)' },
    { value: '1563', label: 'Waterview School (1563)' },
    { value: '1564', label: 'Wesley Intermediate (1564)' },
    { value: '1565', label: 'Wesley Primary School (1565)' },
    { value: '1566', label: 'West Harbour School (1566)' },
    { value: '1567', label: 'Western Heights School (Auckland) (1567)' },
    { value: '1568', label: 'Westmere School (Auckland) (1568)' },
    { value: '1569', label: 'Waimahia Intermediate School (1569)' },
    { value: '1570', label: 'Weymouth School (1570)' },
    { value: '1571', label: 'Whangaparaoa School (Auckland) (1571)' },
    { value: '1572', label: 'Whenuapai School (1572)' },
    { value: '1573', label: 'Willow Park School (1573)' },
    { value: '1574', label: 'Wilson School (1574)' },
    { value: '1575', label: 'Windy Ridge School (1575)' },
    { value: '1576', label: 'Wiri Central School (1576)' },
    { value: '1577', label: 'Woodhill School (1577)' },
    { value: '1578', label: 'Woodlands Park School (1578)' },
    { value: '1579', label: 'Wymondley Road School (1579)' },
    { value: '1580', label: 'Yendarra School (1580)' },
    { value: '1581', label: 'Chapel Downs School (1581)' },
    { value: '1582', label: 'Nova Montessori School (1582)' },
    { value: '1584', label: 'TKKM o Te Raki Paewhenua (1584)' },
    { value: '1585', label: "St Anthony's School (Wanganui) (1585)" },
    { value: '1587', label: 'Gloriavale Christian School (1587)' },
    {
      value: '1588',
      label: 'St Francis Xavier Catholic School (Whangarei) (1588)',
    },
    { value: '1589', label: 'TKKM o Toku Mapihi Maurea (1589)' },
    { value: '1592', label: 'Marina View School (1592)' },
    { value: '1593', label: 'Kaitoke School (Claris) (1593)' },
    { value: '1594', label: 'Riverview School (1594)' },
    { value: '1595', label: 'Titirangi Rudolf Steiner School (1595)' },
    { value: '1606', label: 'UP International College New Zealand (1606)' },
    { value: '1607', label: 'Bishop Edward Gaines Catholic School (1607)' },
    { value: '1608', label: "St Matthew's Primary School (Hastings) (1608)" },
    { value: '1611', label: 'Timaru Christian School (1611)' },
    { value: '1613', label: 'Te Rā School (1613)' },
    { value: '1616', label: 'TKKM o Ngati Kahungunu o Te Wairoa (1616)' },
    { value: '1617', label: 'TKKM o Ngati Rangi (1617)' },
    { value: '1618', label: 'TKKM o Te Whanau Tahi (1618)' },
    { value: '1625', label: 'Ascot Community School (1625)' },
    { value: '1627', label: "St Paul's School (Richmond) (1627)" },
    { value: '1630', label: 'Central Regional Health School (1630)' },
    { value: '1631', label: 'Southern Health School (1631)' },
    { value: '1633', label: 'St Mary MacKillop Catholic School (1633)' },
    { value: '1634', label: 'Te Kura Māori o Porirua (1634)' },
    { value: '1636', label: 'St Thomas More Catholic School (1636)' },
    { value: '1641', label: 'Amana Christian School (1641)' },
    { value: '1643', label: "St Paul's School (Massey) (1643)" },
    { value: '1645', label: 'Te Kura o Tōrere (1645)' },
    { value: '1646', label: 'Wainuiomata Intermediate (1646)' },
    { value: '1647', label: 'Konini Primary School (Wainuiomata) (1647)' },
    { value: '1648', label: 'Manaia View School (1648)' },
    { value: '1650', label: 'Drummond Primary School (1650)' },
    { value: '1651', label: 'TKKM o Wairarapa (1651)' },
    { value: '1655', label: 'Destiny School (1655)' },
    { value: '1657', label: 'Silverstream (South) Primary School (1657)' },
    { value: '1658', label: 'Putāruru Primary School (1658)' },
    { value: '1659', label: 'Lakeview School (1659)' },
    { value: '1660', label: 'Masterton Primary School (1660)' },
    { value: '1661', label: 'Douglas Park School (1661)' },
    { value: '1662', label: 'Huia Range School (1662)' },
    { value: '1663', label: 'Stella Maris Primary School (1663)' },
    { value: '1666', label: 'Te Kura o Waikare (1666)' },
    { value: '1667', label: 'He Puna Ruku Mātauranga o Whangaruru (1667)' },
    { value: '1668', label: 'Wairoa Primary School (1668)' },
    { value: '1669', label: 'Tiaho Primary School (1669)' },
    {
      value: '1670',
      label:
        'Te Ara Whanui Kura Kaupapa Māori o ngā Kōhanga Reo o Te Awa Kairangi (1670)',
    },
    { value: '1672', label: 'TKKM o Nga Uri A Maui (1672)' },
    { value: '1673', label: 'TKKM o Te Waiu o Ngati Porou (1673)' },
    {
      value: '1674',
      label: 'TKKM o Te Wananga Whare Tapere o Takitimu (1674)',
    },
    { value: '1675', label: 'Ruakituri School (1675)' },
    { value: '1676', label: 'Te Mahia School (1676)' },
    { value: '1677', label: 'Mohaka School (1677)' },
    { value: '1678', label: 'Te Kura o Waikaremoana (1678)' },
    { value: '1679', label: 'Rahotu School (1679)' },
    { value: '1680', label: 'Aberdeen School (1680)' },
    { value: '1681', label: 'Allandale School (1681)' },
    { value: '1682', label: 'Amisfield School (1682)' },
    { value: '1683', label: 'Aorangi School (Rotorua) (1683)' },
    { value: '1684', label: 'Apanui School (1684)' },
    { value: '1686', label: 'Arataki School (1686)' },
    { value: '1687', label: 'Āria School (1687)' },
    { value: '1688', label: 'Arohena School (1688)' },
    { value: '1689', label: 'Ashbrook School (1689)' },
    { value: '1691', label: 'Awakeri School (1691)' },
    { value: '1693', label: 'Bankwood School (1693)' },
    { value: '1694', label: 'Bellevue School (Tauranga) (1694)' },
    { value: '1695', label: 'Berkley Normal Middle School (1695)' },
    { value: '1696', label: 'TKKM o Bernard Fergusson (1696)' },
    { value: '1697', label: 'Bethlehem School (1697)' },
    { value: '1698', label: 'Broadlands School (1698)' },
    { value: '1699', label: 'Te Kura o Manunui (1699)' },
    { value: '1700', label: 'Cambridge East School (1700)' },
    { value: '1701', label: 'Cambridge Middle School (1701)' },
    { value: '1702', label: 'Cambridge School (1702)' },
    { value: '1704', label: 'Cargill Open Plan School (1704)' },
    { value: '1705', label: 'Centennial Park School (1705)' },
    { value: '1706', label: 'Colville School (1706)' },
    { value: '1707', label: 'Coroglen School (1707)' },
    { value: '1708', label: 'David Henry School (1708)' },
    { value: '1709', label: 'David Street School (1709)' },
    { value: '1710', label: 'Deanwell School (1710)' },
    { value: '1711', label: 'Edgecumbe School (1711)' },
    { value: '1713', label: 'Elstow-Waihou Combined School (1713)' },
    { value: '1715', label: 'Fairfield Intermediate (1715)' },
    { value: '1716', label: 'Fairfield Primary School (1716)' },
    { value: '1717', label: 'Fairhaven School (1717)' },
    { value: '1718', label: 'Te Wharekura o Kirikiriroa (1718)' },
    { value: '1719', label: 'Firth School (1719)' },
    { value: '1720', label: 'Forest Lake School (1720)' },
    { value: '1721', label: 'Frankton School (1721)' },
    { value: '1722', label: 'Galatea School (1722)' },
    { value: '1723', label: 'Glen Massey School (1723)' },
    { value: '1724', label: 'Glenholme School (1724)' },
    { value: '1725', label: 'Glenview School (Hamilton) (1725)' },
    { value: '1726', label: 'Goldfields School (Paeroa) (1726)' },
    { value: '1727', label: 'Goodwood School (1727)' },
    { value: '1728', label: 'Gordonton School (1728)' },
    { value: '1729', label: 'Greenpark School (Tauranga) (1729)' },
    {
      value: '1730',
      label: 'Greerton Village School - Te Kura o Maarawaewae (1730)',
    },
    { value: '1731', label: 'Hamilton East School (1731)' },
    { value: '1732', label: 'Hamilton North School (1732)' },
    { value: '1733', label: 'Hamilton West School (1733)' },
    { value: '1735', label: 'Hautapu School (1735)' },
    { value: '1736', label: 'Hauturu School (1736)' },
    { value: '1737', label: 'Hikuai School (1737)' },
    { value: '1738', label: 'Hikutaia School (1738)' },
    { value: '1739', label: 'Hillcrest Normal School (1739)' },
    { value: '1740', label: 'Hilltop School (1740)' },
    { value: '1741', label: 'Hinuera School (1741)' },
    { value: '1744', label: 'Horahora School (Cambridge) (1744)' },
    { value: '1745', label: 'Horohoro School (1745)' },
    { value: '1746', label: 'Horotiu School (1746)' },
    { value: '1747', label: 'Horsham Downs School (1747)' },
    { value: '1748', label: 'TKKM o Huiarau (1748)' },
    { value: '1749', label: 'Hukanui School (1749)' },
    { value: '1750', label: "St Patrick's Catholic School (Taupo) (1750)" },
    { value: '1751', label: 'Huntly School (Waikato) (1751)' },
    { value: '1752', label: 'Huntly West School (1752)' },
    { value: '1753', label: 'Insoll Avenue School (1753)' },
    { value: '1754', label: 'Rangitaiki School (1754)' },
    { value: '1755', label: 'James Street School (1755)' },
    { value: '1756', label: 'Kaharoa School (1756)' },
    { value: '1757', label: 'Kaihere School (1757)' },
    { value: '1758', label: 'Kaimai School (1758)' },
    { value: '1759', label: 'Kaingaroa Forest School (1759)' },
    { value: '1760', label: 'Kaipaki School (1760)' },
    { value: '1761', label: 'Kaitao Intermediate (1761)' },
    { value: '1762', label: 'Tauranga Special School (1762)' },
    { value: '1763', label: 'Karangahake School (1763)' },
    { value: '1764', label: 'Karapiro School (1764)' },
    { value: '1765', label: 'Katikati Primary School (1765)' },
    { value: '1766', label: 'Kawaha Point School (1766)' },
    { value: '1770', label: 'Kawerau South School (1770)' },
    { value: '1771', label: 'Kawhia School (1771)' },
    {
      value: '1772',
      label: 'Rotorua Specialist School - Te Kura Pūkenga o Rotorua (1772)',
    },
    { value: '1773', label: 'TKKM o Harataunga (1773)' },
    { value: '1775', label: 'Kerepehi School (1775)' },
    { value: '1776', label: 'Kihikihi School (1776)' },
    { value: '1777', label: 'Kimihia School (1777)' },
    { value: '1778', label: 'Kinohaku School (1778)' },
    { value: '1779', label: 'Kio Kio School (1779)' },
    { value: '1780', label: 'Kiwitahi School (1780)' },
    { value: '1781', label: 'Knighton Normal School (1781)' },
    { value: '1782', label: 'Kopuarahi School (1782)' },
    { value: '1783', label: 'Korakonui School (1783)' },
    { value: '1784', label: 'Koromatua School (1784)' },
    { value: '1785', label: 'Kuratau School (1785)' },
    { value: '1786', label: 'Kutarere School (1786)' },
    { value: '1787', label: 'Lake Rerewhakaaitu School (1787)' },
    { value: '1788', label: 'Lake Rotoma School (1788)' },
    { value: '1789', label: 'Leamington School (1789)' },
    { value: '1790', label: 'Lichfield School (1790)' },
    { value: '1791', label: 'Lynmore Primary School (1791)' },
    { value: '1792', label: 'Maeroa Intermediate (1792)' },
    { value: '1793', label: 'Maihiihi School (1793)' },
    { value: '1794', label: 'Maketu School (1794)' },
    { value: '1796', label: 'Malfroy School (1796)' },
    { value: '1797', label: 'Mamaku School (1797)' },
    { value: '1798', label: 'Te Wharekura o Manaia (1798)' },
    { value: '1800', label: 'Manawaru School (1800)' },
    { value: '1806', label: 'Te Kura Mana Māori o Maraenui (1806)' },
    { value: '1808', label: 'Marotiri School (1808)' },
    { value: '1809', label: 'Te Kura Mana Maori o Matahi (1809)' },
    { value: '1811', label: 'Te Kura o Te Moutere O Matakana (1811)' },
    { value: '1812', label: 'Matamata Intermediate (1812)' },
    { value: '1813', label: 'Matamata Primary School (1813)' },
    { value: '1814', label: 'Matangi School (1814)' },
    { value: '1815', label: 'Te Kura o Matapihi (1815)' },
    { value: '1818', label: 'Matata School (1818)' },
    { value: '1819', label: 'Matatoki School (1819)' },
    { value: '1820', label: 'Matua School (1820)' },
    { value: '1821', label: 'Maungatapu School (1821)' },
    { value: '1824', label: 'Melville Primary School (1824)' },
    { value: '1825', label: 'Merivale School (1825)' },
    { value: '1826', label: 'Mihi School (1826)' },
    { value: '1827', label: 'Miller Avenue School (1827)' },
    { value: '1829', label: 'Moanataiari School (1829)' },
    { value: '1832', label: 'Mokoia Intermediate (1832)' },
    { value: '1833', label: 'Morrinsville Intermediate (1833)' },
    { value: '1834', label: 'Morrinsville School (1834)' },
    { value: '1835', label: 'Motumaoho School (1835)' },
    { value: '1836', label: 'Mountview School (1836)' },
    { value: '1837', label: 'Mt Maunganui Intermediate (1837)' },
    { value: '1838', label: 'Mount Maunganui Primary School (1838)' },
    { value: '1841', label: 'Nawton School (1841)' },
    { value: '1842', label: 'Netherton School (1842)' },
    { value: '1843', label: 'Newstead Model School (1843)' },
    { value: '1844', label: 'Ngahinapouri School (1844)' },
    { value: '1845', label: 'Ngakonui Valley School (1845)' },
    { value: '1846', label: 'Ngakuru School (1846)' },
    { value: '1847', label: 'Te Kura o Ngāpuke (1847)' },
    { value: '1849', label: 'Ngaruawahia School (1849)' },
    { value: '1850', label: 'Ngatea School (1850)' },
    { value: '1851', label: 'Te Kura o Ngaati Hauaa (1851)' },
    { value: '1852', label: 'Ngongotaha School (1852)' },
    { value: '1853', label: 'Ngutunui School (1853)' },
    { value: '1854', label: 'Nukuhou North School (1854)' },
    { value: '1855', label: 'Ohaupo School (1855)' },
    { value: '1856', label: 'Ohinewai School (1856)' },
    { value: '1857', label: 'Ōhope Beach School (1857)' },
    { value: '1858', label: 'Kuranui Primary School (1858)' },
    { value: '1860', label: 'Omanu School (1860)' },
    { value: '1861', label: 'Te Kura o Ōmarumutu (1861)' },
    { value: '1862', label: 'Ōmokoroa Point School (1862)' },
    { value: '1863', label: 'Omokoroa School (1863)' },
    { value: '1865', label: 'Te Wharekura o Maniapoto (1865)' },
    { value: '1866', label: 'Opotiki School (1866)' },
    { value: '1867', label: 'Ōpoutere School (1867)' },
    { value: '1869', label: 'Orini Combined School (1869)' },
    { value: '1870', label: 'Oropi School (1870)' },
    { value: '1871', label: 'Otakiri School (1871)' },
    { value: '1872', label: 'Otamarakau School (1872)' },
    { value: '1873', label: 'TKKM o Otepou (1873)' },
    { value: '1874', label: 'Ōtewā School (1874)' },
    { value: '1875', label: 'Otonga Road School (1875)' },
    { value: '1876', label: 'Ōtorohanga School (1876)' },
    { value: '1877', label: 'Otorohanga South School (1877)' },
    { value: '1878', label: 'Ōtūmoetai Intermediate (1878)' },
    { value: '1879', label: 'Ōtūmoetai Primary School (1879)' },
    { value: '1880', label: "St Mary's Catholic School (Otorohanga) (1880)" },
    { value: '1881', label: 'Owhata School (1881)' },
    { value: '1882', label: 'Paengaroa School (1882)' },
    { value: '1883', label: 'Paeroa Central School (1883)' },
    { value: '1884', label: 'Pahoia School (1884)' },
    { value: '1885', label: 'Pāpāmoa Primary School (1885)' },
    { value: '1886', label: 'Pārāwai School (1886)' },
    { value: '1888', label: 'Te Kura o Te Paroa (1888)' },
    { value: '1889', label: 'Paterangi School (1889)' },
    { value: '1891', label: 'Patricia Avenue School (1891)' },
    { value: '1892', label: 'Peachgrove Intermediate (1892)' },
    { value: '1893', label: 'Pekapekarau School (1893)' },
    { value: '1894', label: 'Pillans Point School (1894)' },
    { value: '1895', label: 'Piopio Primary School (1895)' },
    { value: '1896', label: 'Piripiri School (1896)' },
    { value: '1897', label: 'Pirongia School (1897)' },
    { value: '1898', label: 'Pokuru School (1898)' },
    { value: '1899', label: 'Pongakawa School (1899)' },
    { value: '1902', label: 'Puahue School (1902)' },
    { value: '1903', label: 'Pukeatua School (1903)' },
    { value: '1904', label: 'Pukehina School (1904)' },
    { value: '1906', label: 'Pukenui School (Te Kuiti) (1906)' },
    { value: '1907', label: 'Puketaha School (1907)' },
    { value: '1908', label: 'Pukete School (1908)' },
    { value: '1911', label: 'Puriri School (1911)' },
    { value: '1912', label: 'Te Puru School (1912)' },
    { value: '1916', label: 'Pyes Pa Road School (1916)' },
    { value: '1917', label: 'Te Wharekura o Rākaumangamanga (1917)' },
    { value: '1919', label: 'Te Kura o Rangiriri (1919)' },
    { value: '1920', label: 'Rangitoto School (1920)' },
    { value: '1921', label: 'Rangiuru School (1921)' },
    { value: '1923', label: 'Reporoa School (1923)' },
    { value: '1924', label: 'Rhode Street School (1924)' },
    { value: '1927', label: 'Roto-O-Rangi School (1927)' },
    { value: '1929', label: 'TKKM o Rotoiti (1929)' },
    { value: '1930', label: 'Rotokauri School (1930)' },
    { value: '1931', label: 'Rotokawa School (1931)' },
    { value: '1933', label: 'Rotorua Intermediate (1933)' },
    { value: '1934', label: 'Rotorua School (1934)' },
    { value: '1935', label: 'Ficino School (1935)' },
    { value: '1937', label: 'Ruawaro Combined School (1937)' },
    { value: '1938', label: 'Rukuhia School (1938)' },
    { value: '1939', label: 'Selwyn School (1939)' },
    { value: '1940', label: 'Silverdale Normal School (1940)' },
    { value: '1941', label: 'Springdale School (1941)' },
    { value: '1942', label: 'St Andrews Middle School (1942)' },
    { value: '1943', label: "St Anthony's Catholic School (Huntly) (1943)" },
    { value: '1944', label: "St Columba's Catholic School (Frankton) (1944)" },
    { value: '1945', label: 'St Francis School (Thames) (1945)' },
    { value: '1946', label: "St Joseph's Catholic School (Fairfield) (1946)" },
    { value: '1947', label: "St Joseph's Catholic School (Matamata) (1947)" },
    { value: '1948', label: "St Joseph's Catholic School (Matata) (1948)" },
    {
      value: '1949',
      label: "St Joseph's Catholic School (Morrinsville) (1949)",
    },
    { value: '1950', label: "St Joseph's Catholic School (Opotiki) (1950)" },
    { value: '1951', label: "St Joseph's Catholic School (Paeroa) (1951)" },
    { value: '1952', label: "St Joseph's Catholic School (Te Aroha) (1952)" },
    { value: '1953', label: "St Joseph's Catholic School (Te Kuiti) (1953)" },
    { value: '1954', label: "St Joseph's Catholic School (Waihi) (1954)" },
    { value: '1955', label: "St Joseph's Catholic School (Whakatane) (1955)" },
    { value: '1957', label: "St Mary's Catholic School (Putāruru) (1957)" },
    { value: '1958', label: "St Mary's Catholic School (Rotorua) (1958)" },
    { value: '1959', label: "St Mary's Catholic School (Tauranga) (1959)" },
    { value: '1960', label: "St Michael's Catholic School (Rotorua) (1960)" },
    {
      value: '1961',
      label: "St Patrick's Catholic School (Taumarunui) (1961)",
    },
    {
      value: '1962',
      label: "St Patrick's Catholic School (Te Awamutu) (1962)",
    },
    { value: '1963', label: "St Paul's Catholic School (Ngaruawahia) (1963)" },
    {
      value: '1964',
      label: 'St Peter Chanel Catholic School (Te Rapa) (1964)',
    },
    { value: '1965', label: "St Peter's Catholic School (Cambridge) (1965)" },
    { value: '1966', label: 'St Pius X Catholic School (Melville) (1966)' },
    { value: '1967', label: 'Stanley Avenue School (1967)' },
    { value: '1968', label: 'Strathmore School (1968)' },
    { value: '1970', label: 'Sunset Primary School (1970)' },
    { value: '1971', label: 'Te Kura o Tahaaroa (1971)' },
    { value: '1972', label: 'Tahuna School (1972)' },
    { value: '1974', label: 'Tainui Full Primary School (1974)' },
    { value: '1975', label: 'Tairua School (1975)' },
    { value: '1976', label: 'Tamahere Model Country School (1976)' },
    { value: '1978', label: 'Taneatua School (1978)' },
    { value: '1980', label: 'Tapu School (1980)' },
    { value: '1982', label: 'Tarrangower School (1982)' },
    { value: '1983', label: 'Tatuanui School (1983)' },
    { value: '1984', label: 'Tauhara School (1984)' },
    { value: '1985', label: 'Tauhei Combined School (1985)' },
    { value: '1986', label: 'Taumarunui Primary School (1986)' },
    { value: '1987', label: 'Taupiri School (1987)' },
    { value: '1988', label: 'Taupo Intermediate (1988)' },
    { value: '1989', label: 'Taupo School (1989)' },
    { value: '1990', label: 'Tauranga Intermediate (1990)' },
    { value: '1991', label: 'Tauranga Primary School (1991)' },
    { value: '1992', label: 'Gate Pa School (1992)' },
    { value: '1994', label: 'Tauriko School (1994)' },
    { value: '1995', label: 'Tauwhare School (1995)' },
    { value: '1996', label: 'Tāwera Bilingual School (1996)' },
    { value: '1998', label: 'Te Akau School (1998)' },
    { value: '1999', label: 'Te Aroha Primary School (1999)' },
    { value: '2001', label: 'Te Awamutu Intermediate (2001)' },
    { value: '2002', label: 'Te Awamutu Primary School (2002)' },
    { value: '2005', label: 'Te Kauwhata Primary School (2005)' },
    { value: '2007', label: 'Te Kowhai School (2007)' },
    { value: '2008', label: 'Te Kuiti Primary School (2008)' },
    { value: '2009', label: 'Te Mahoe School (2009)' },
    { value: '2010', label: 'Te Mata School (Raglan) (2010)' },
    { value: '2011', label: 'TKKM o Te Matai (2011)' },
    { value: '2012', label: 'Te Miro School (2012)' },
    { value: '2013', label: 'Te Pahu School (2013)' },
    { value: '2014', label: 'Te Poi School (2014)' },
    { value: '2015', label: 'Te Puke Intermediate (2015)' },
    { value: '2016', label: 'Te Puke Primary School (2016)' },
    { value: '2017', label: 'Te Puna School (2017)' },
    { value: '2019', label: 'Te Ranga School (2019)' },
    { value: '2020', label: 'Te Rapa School (2020)' },
    { value: '2021', label: 'Te Rerenga School (2021)' },
    { value: '2023', label: 'Te Kura o Te Teko (2023)' },
    { value: '2024', label: 'Te Uku School (2024)' },
    { value: '2025', label: 'Te Waotu School (2025)' },
    { value: '2027', label: 'Thames South School (2027)' },
    { value: '2028', label: 'Thornton School (2028)' },
    { value: '2031', label: 'Tirau Primary School (2031)' },
    { value: '2032', label: 'Tirohanga School (2032)' },
    { value: '2033', label: 'Tirohia School (2033)' },
    { value: '2035', label: 'Tokoroa Central School (2035)' },
    { value: '2037', label: 'Tokoroa Intermediate (2037)' },
    { value: '2038', label: 'Tokoroa North School (2038)' },
    { value: '2040', label: 'Turaki School (2040)' },
    { value: '2043', label: 'Turua Primary School (2043)' },
    { value: '2044', label: 'Upper Atiamuri School (2044)' },
    { value: '2045', label: 'Vardon School (2045)' },
    { value: '2046', label: 'Waerenga School (2046)' },
    { value: '2047', label: 'Te Kura o Waharoa (2047)' },
    { value: '2048', label: 'Waihi Beach School (2048)' },
    { value: '2049', label: 'Waihi East School (2049)' },
    { value: '2050', label: 'Waihi Central School (2050)' },
    { value: '2052', label: 'Waikaretu School (2052)' },
    { value: '2054', label: 'Waikino School (2054)' },
    { value: '2055', label: 'Waikite Valley School (2055)' },
    { value: '2057', label: 'Waimana School (2057)' },
    { value: '2058', label: 'Waimata School (2058)' },
    { value: '2060', label: 'Waingaro School (2060)' },
    { value: '2061', label: 'Te Kura o Waioweka (2061)' },
    { value: '2062', label: 'Te Kura Māori ā Rohe o Waiohau (2062)' },
    { value: '2063', label: 'Waiotahe Valley School (2063)' },
    { value: '2064', label: 'Waipa School (2064)' },
    { value: '2065', label: 'Waipahihi School (2065)' },
    { value: '2066', label: 'Wairakei School (2066)' },
    { value: '2068', label: 'Te Kura o Waitahanui (2068)' },
    { value: '2069', label: 'Waitakaruru School (2069)' },
    { value: '2071', label: 'Waitetuna School (2071)' },
    { value: '2073', label: 'Waitomo Caves School (2073)' },
    { value: '2074', label: 'Walton School (2074)' },
    { value: '2075', label: 'Wairere School (2075)' },
    { value: '2076', label: 'Welcome Bay School (2076)' },
    { value: '2077', label: 'Westbrook School (2077)' },
    { value: '2078', label: 'Western Heights Primary School (Rotorua) (2078)' },
    { value: '2079', label: 'Whakamarama School (2079)' },
    { value: '2080', label: 'Whakamaru School (2080)' },
    { value: '2081', label: 'Whakarewarewa School (2081)' },
    { value: '2082', label: 'Whakatane Intermediate (2082)' },
    { value: '2083', label: 'Whangamarino School (2083)' },
    { value: '2084', label: 'Te Kura Mana Māori o Whangaparaoa (2084)' },
    { value: '2085', label: 'ACG Parnell College (2085)' },
    { value: '2086', label: 'Wharepapa South School (2086)' },
    { value: '2087', label: 'Whatawhata School (2087)' },
    { value: '2088', label: 'Whenuakite School (2088)' },
    { value: '2090', label: 'Whitikahu School (2090)' },
    { value: '2091', label: 'Whitiora School (2091)' },
    { value: '2092', label: 'Woodlands School (Opotiki) (2092)' },
    { value: '2093', label: 'Woodstock School (2093)' },
    { value: '2094', label: 'Marian Catholic School (Hamilton) (2094)' },
    { value: '2095', label: 'Kaponga School (2095)' },
    { value: '2096', label: 'Crawshaw School (2096)' },
    { value: '2097', label: 'Manaia School (Taranaki) (2097)' },
    { value: '2098', label: 'Matapu School (2098)' },
    { value: '2099', label: 'Trentham School (2099)' },
    { value: '2100', label: 'Koraunui School (2100)' },
    { value: '2101', label: 'Tautoro School (2101)' },
    { value: '2102', label: 'Maromaku School (2102)' },
    { value: '2103', label: 'Moerewa School (2103)' },
    { value: '2104', label: 'TKKM o Taumarere (2104)' },
    { value: '2105', label: 'Awahono School - Grey Valley (2105)' },
    { value: '2106', label: 'Paparoa Range School (2106)' },
    { value: '2107', label: 'Geraldine Primary School (2107)' },
    { value: '2108', label: 'Winchester Rural School (2108)' },
    { value: '2109', label: 'Temuka Primary School (2109)' },
    { value: '2110', label: 'Oceanview Heights School (2110)' },
    { value: '2111', label: 'Grantlea Downs School (2111)' },
    { value: '2112', label: 'Barton Rural School (2112)' },
    { value: '2113', label: 'Bluestone School (2113)' },
    { value: '2114', label: 'Beaconsfield School (2114)' },
    { value: '2115', label: 'Timaru South School (2115)' },
    { value: '2116', label: 'New River Primary (2116)' },
    { value: '2117', label: 'Fernworth Primary School (2117)' },
    { value: '2118', label: 'Newfield Park School (2118)' },
    { value: '2119', label: 'Donovan Primary School (2119)' },
    { value: '2120', label: 'Bluff School (2120)' },
    { value: '2123', label: 'Lake Brunner School (2123)' },
    { value: '2150', label: 'Ahititi School (2150)' },
    { value: '2152', label: 'Auroa School (2152)' },
    { value: '2153', label: 'Avon School (2153)' },
    { value: '2157', label: 'Bell Block School (2157)' },
    { value: '2160', label: 'Central School Te Kura Waenga O Ngāmotu (2160)' },
    { value: '2161', label: 'Devon Intermediate (2161)' },
    { value: '2164', label: 'Egmont Village School (2164)' },
    { value: '2165', label: 'Eltham School (2165)' },
    { value: '2167', label: 'Fitzroy School (2167)' },
    { value: '2168', label: 'Frankley School (2168)' },
    { value: '2171', label: 'Hāwera Primary School (2171)' },
    { value: '2172', label: 'Highlands Intermediate (2172)' },
    { value: '2173', label: 'Huiakama School (2173)' },
    { value: '2175', label: 'Huirangi School (2175)' },
    { value: '2177', label: 'Inglewood Primary School (2177)' },
    { value: '2178', label: 'Kaimata School (2178)' },
    { value: '2182', label: 'Lepperton School (2182)' },
    { value: '2185', label: 'Makahu School (2185)' },
    { value: '2189', label: 'Mangorei School (2189)' },
    { value: '2190', label: 'Manukorihi Intermediate (2190)' },
    { value: '2191', label: 'Marco School (2191)' },
    { value: '2192', label: 'Marfell Community School (2192)' },
    { value: '2195', label: 'Matiere School (2195)' },
    { value: '2197', label: 'Merrilands School (2197)' },
    { value: '2198', label: 'Midhirst School (2198)' },
    { value: '2199', label: 'Mimi School (2199)' },
    { value: '2200', label: 'Mokau School (2200)' },
    { value: '2201', label: 'Mokoia School (2201)' },
    { value: '2203', label: 'Moturoa School (2203)' },
    { value: '2205', label: 'Ngaere School (2205)' },
    { value: '2206', label: 'Norfolk School (2206)' },
    { value: '2207', label: 'Normanby School (2207)' },
    { value: '2208', label: 'Oakura School (2208)' },
    { value: '2214', label: 'Ōmata School (2214)' },
    { value: '2215', label: 'Ongarue School (2215)' },
    { value: '2216', label: 'Opunake School (2216)' },
    { value: '2220', label: 'Pembroke School (2220)' },
    { value: '2223', label: 'Puketapu School (New Plymouth) (2223)' },
    { value: '2226', label: 'Ramanui School (2226)' },
    { value: '2227', label: 'Ratapiko School (2227)' },
    { value: '2228', label: 'Rawhitiroa School (2228)' },
    { value: '2232', label: 'Spotswood Primary School (2232)' },
    { value: '2233', label: 'St John Bosco School (New Plymouth) (2233)' },
    { value: '2235', label: "St Joseph's School (Hawera) (2235)" },
    { value: '2236', label: "St Joseph's School (New Plymouth) (2236)" },
    { value: '2237', label: "St Joseph's School (Opunake) (2237)" },
    { value: '2238', label: "St Joseph's School (Stratford) (2238)" },
    { value: '2239', label: "St Joseph's School (Waitara) (2239)" },
    { value: '2240', label: "St Patrick's School (Kaponga) (2240)" },
    { value: '2241', label: "St Patrick's School (Inglewood) (2241)" },
    { value: '2242', label: 'St Pius X School (New Plymouth) (2242)' },
    { value: '2244', label: 'Stratford Primary School (2244)' },
    { value: '2248', label: 'Tawhiti School (2248)' },
    { value: '2251', label: 'Tikorangi School (2251)' },
    { value: '2253', label: 'Tokirima School (2253)' },
    { value: '2254', label: 'Toko School (2254)' },
    { value: '2255', label: 'Turuturu School (2255)' },
    { value: '2256', label: 'Urenui School (2256)' },
    { value: '2257', label: 'Uruti School (2257)' },
    { value: '2258', label: 'Vogeltown School (2258)' },
    { value: '2260', label: 'Waitara Central School (2260)' },
    { value: '2261', label: 'Waitara East School (2261)' },
    { value: '2262', label: 'Waitoriki School (2262)' },
    { value: '2264', label: 'Welbourn School (2264)' },
    { value: '2265', label: 'West End Te Kura O Morere (2265)' },
    { value: '2266', label: 'Westown School (2266)' },
    { value: '2267', label: 'Whareorino School (2267)' },
    { value: '2268', label: 'Woodleigh School (2268)' },
    { value: '2330', label: 'Aberfeldy School (2330)' },
    { value: '2332', label: 'Aokautere School (2332)' },
    { value: '2333', label: 'Apiti School (2333)' },
    { value: '2334', label: 'Arahunga School (2334)' },
    { value: '2336', label: 'Aranui School (Wanganui) (2336)' },
    { value: '2337', label: 'Ashhurst School (2337)' },
    { value: '2338', label: 'Awahou School (2338)' },
    { value: '2339', label: 'Awapuni School (P North) (2339)' },
    { value: '2341', label: 'Bainesse School (2341)' },
    { value: '2342', label: 'Brunswick School (2342)' },
    { value: '2343', label: 'Bulls School (2343)' },
    { value: '2344', label: 'Bunnythorpe School (2344)' },
    { value: '2345', label: 'Carlton School (2345)' },
    { value: '2346', label: 'Castlecliff School (2346)' },
    { value: '2348', label: 'Churton School (2348)' },
    { value: '2349', label: 'Clifton School (Bulls) (2349)' },
    { value: '2350', label: 'Cloverlea School (2350)' },
    { value: '2351', label: 'TKKM o Otepoti (2351)' },
    { value: '2352', label: 'Coley Street School (2352)' },
    { value: '2353', label: 'College Street Normal School (2353)' },
    { value: '2354', label: 'Colyton School (2354)' },
    { value: '2355', label: 'Durie Hill School (2355)' },
    { value: '2356', label: 'Feilding Intermediate (2356)' },
    { value: '2357', label: 'Fordell School (2357)' },
    { value: '2358', label: 'Foxton Beach School (2358)' },
    { value: '2359', label: 'Foxton School (2359)' },
    { value: '2360', label: 'Glen Oroua School (2360)' },
    { value: '2361', label: 'Gonville School (2361)' },
    { value: '2362', label: 'Halcombe Primary School (2362)' },
    { value: '2363', label: 'Te Kura o Wairau (2363)' },
    { value: '2364', label: 'Hiwinui School (2364)' },
    { value: '2365', label: 'Hokowhitu School (2365)' },
    { value: '2366', label: 'Hunterville Consolidated School (2366)' },
    { value: '2368', label: 'James Cook School (2368)' },
    { value: '2369', label: 'Kai Iwi School (2369)' },
    { value: '2370', label: 'Kairanga School (2370)' },
    { value: '2371', label: 'Kaitieke School (2371)' },
    { value: '2372', label: 'Kaitoke School (Wanganui) (2372)' },
    { value: '2374', label: 'Kakaramea School (2374)' },
    { value: '2375', label: 'Kakatahi School (2375)' },
    { value: '2377', label: 'TKKM o Tupoho (2377)' },
    { value: '2378', label: 'Keith Street School (2378)' },
    { value: '2379', label: 'Kimbolton School (2379)' },
    { value: '2382', label: 'Kiwitea School (2382)' },
    { value: '2383', label: 'TKKM o Ngati Ruanui (2383)' },
    { value: '2384', label: 'Te Kura o Kokohuia (2384)' },
    { value: '2385', label: 'Kopane School (2385)' },
    { value: '2386', label: 'Linton Camp School (2386)' },
    { value: '2388', label: 'Longburn School (2388)' },
    { value: '2389', label: 'Lytton Street School (2389)' },
    { value: '2390', label: 'Manchester Street School (2390)' },
    { value: '2391', label: 'Mangamahu Primary School (2391)' },
    { value: '2392', label: 'Mangaweka School (2392)' },
    { value: '2393', label: 'Manunui School (2393)' },
    { value: '2395', label: 'St Marcellin School (Wanganui) (2395)' },
    { value: '2396', label: 'Marton Junction School (2396)' },
    { value: '2397', label: 'Marton School (2397)' },
    { value: '2398', label: 'Mataroa School (2398)' },
    { value: '2400', label: 'Milson School (2400)' },
    { value: '2401', label: 'Moawhango School (2401)' },
    { value: '2402', label: 'Monrad - Te Kura Waenga o Tirohanga (2402)' },
    { value: '2403', label: 'Mosston School (2403)' },
    { value: '2404', label: 'Mount Biggs School (2404)' },
    { value: '2405', label: 'National Park School (2405)' },
    { value: '2406', label: 'Newbury School (2406)' },
    { value: '2407', label: 'Ngamatapouri School (2407)' },
    { value: '2409', label: 'North Street School (2409)' },
    { value: '2410', label: 'Ohakune School (2410)' },
    { value: '2412', label: 'Okoia School (2412)' },
    { value: '2413', label: 'Orautoha School (2413)' },
    { value: '2414', label: 'Oroua Downs School (2414)' },
    { value: '2416', label: 'Our Lady of Lourdes School (P North) (2416)' },
    { value: '2417', label: 'Ōwhango School (2417)' },
    { value: '2418', label: 'Central Normal School (2418)' },
    { value: '2419', label: 'Palmerston North Intermediate (2419)' },
    { value: '2420', label: 'Papanui Junction School (2420)' },
    { value: '2424', label: 'Parkland School (P North) (2424)' },
    { value: '2428', label: 'Pukeokahu School (2428)' },
    { value: '2429', label: 'Raetihi Primary School (2429)' },
    { value: '2436', label: 'Whare Kura Morehu ō Ratana (2436)' },
    { value: '2437', label: 'Riverdale School (P North) (2437)' },
    { value: '2438', label: 'Rongotea School (2438)' },
    { value: '2439', label: 'Roslyn School (2439)' },
    { value: '2440', label: 'Ross Intermediate (2440)' },
    { value: '2441', label: 'Russell Street School (2441)' },
    {
      value: '2442',
      label:
        'Te Kura Waenga O Rutherford | Rutherford Intermediate School (2442)',
    },
    { value: '2443', label: 'Sanson School (2443)' },
    { value: '2445', label: 'TKKM o Ngati Kahungunu Ki Heretaunga (2445)' },
    { value: '2446', label: 'South Makirikiri School (2446)' },
    { value: '2447', label: "St Anne's School (Wanganui) (2447)" },
    {
      value: '2449',
      label: "St James' Catholic School Te Kura Katorika o Hato Heemi (2449)",
    },
    { value: '2450', label: 'St Johns Hill School (2450)' },
    { value: '2451', label: "St Joseph's School (Feilding) (2451)" },
    { value: '2452', label: "St Joseph's School (Patea) (2452)" },
    { value: '2453', label: "St Joseph's School (Taihape) (2453)" },
    { value: '2454', label: "St Mary's School (Wanganui) (2454)" },
    { value: '2455', label: "St Mary's School (Foxton) (2455)" },
    { value: '2456', label: "St Matthew's School (Marton) (2456)" },
    { value: '2457', label: "St Mary's School (P North) (2457)" },
    { value: '2460', label: 'Takaro School (2460)' },
    { value: '2461', label: 'Tangimoana School (2461)' },
    { value: '2462', label: 'Taonui School (2462)' },
    { value: '2463', label: 'Taoroa School (2463)' },
    { value: '2465', label: 'Tawhero School (2465)' },
    { value: '2466', label: 'Terrace End School (2466)' },
    { value: '2467', label: 'Turitea School (2467)' },
    { value: '2468', label: 'Turakina School (2468)' },
    { value: '2469', label: 'Upokongaro School (2469)' },
    { value: '2472', label: 'Waiouru School (2472)' },
    { value: '2474', label: 'Waitotara School (2474)' },
    { value: '2475', label: 'Waituna West School (2475)' },
    { value: '2476', label: 'Whanganui East School (2476)' },
    { value: '2477', label: 'Whanganui Intermediate (2477)' },
    { value: '2478', label: 'Waverley Primary School (2478)' },
    { value: '2479', label: 'West End School (P North) (2479)' },
    { value: '2480', label: 'Westmere School - Whanganui (2480)' },
    { value: '2481', label: 'Whakarongo School (2481)' },
    { value: '2482', label: 'Whangaehu School (2482)' },
    { value: '2483', label: 'Whenuakura School (2483)' },
    { value: '2484', label: 'Winchester School (P North) (2484)' },
    { value: '2542', label: 'Argyll East School (2542)' },
    { value: '2543', label: 'Arthur Miller School (2543)' },
    { value: '2544', label: 'Awapuni School (Gisborne) (2544)' },
    { value: '2546', label: 'Bledisloe School (2546)' },
    { value: '2547', label: 'Bridge Pa School (2547)' },
    { value: '2548', label: 'Camberley School (2548)' },
    { value: '2549', label: 'Clive School (2549)' },
    { value: '2553', label: 'Dannevirke South School (2553)' },
    { value: '2554', label: 'Ebbett Park School (2554)' },
    { value: '2555', label: 'Elgin School (2555)' },
    { value: '2556', label: 'Elsthorpe School (2556)' },
    { value: '2557', label: 'Eskdale School (2557)' },
    { value: '2558', label: 'Fairhaven School (Napier) (2558)' },
    { value: '2560', label: 'Flaxmere Primary School (2560)' },
    { value: '2561', label: 'Flemington School (Waipukurau) (2561)' },
    { value: '2562', label: 'Frasertown School (2562)' },
    { value: '2563', label: 'Frimley School (2563)' },
    { value: '2564', label: 'Gisborne Central School (2564)' },
    { value: '2566', label: 'Gisborne Intermediate (2566)' },
    { value: '2567', label: 'Greenmeadows School (2567)' },
    { value: '2569', label: 'Hastings Central School (2569)' },
    { value: '2570', label: 'Hastings Intermediate (2570)' },
    { value: '2571', label: 'Haumoana School (2571)' },
    { value: '2572', label: 'Havelock North Intermediate (2572)' },
    { value: '2573', label: 'Havelock North Primary School (2573)' },
    { value: '2574', label: 'Henry Hill School (2574)' },
    { value: '2575', label: 'Heretaunga Intermediate (2575)' },
    { value: '2578', label: 'Hiruharama School (2578)' },
    { value: '2581', label: 'Ilminster Intermediate (2581)' },
    { value: '2582', label: 'Irongate School (2582)' },
    { value: '2584', label: 'Kaiti School (2584)' },
    { value: '2585', label: 'Kereru School (2585)' },
    { value: '2587', label: 'Kotemaori School (2587)' },
    { value: '2588', label: 'Kōwhai School (2588)' },
    { value: '2590', label: 'Lucknow School (2590)' },
    { value: '2592', label: 'Mahora School (2592)' },
    { value: '2593', label: 'Makaraka School (2593)' },
    { value: '2594', label: 'Makarika School (2594)' },
    { value: '2595', label: 'Makauri School (2595)' },
    { value: '2597', label: 'Mangapapa School (2597)' },
    { value: '2599', label: 'Mangateretere School (2599)' },
    { value: '2600', label: 'TKKM o Mangatuna (2600)' },
    { value: '2602', label: 'Manutuke School (2602)' },
    { value: '2604', label: 'Maraenui Bilingual School (Napier) (2604)' },
    { value: '2606', label: 'Marewa School (2606)' },
    { value: '2609', label: 'Te Kura o Mata (2609)' },
    { value: '2611', label: 'Matawai School (2611)' },
    { value: '2612', label: 'Mayfair School (2612)' },
    { value: '2613', label: 'Meeanee School (2613)' },
    { value: '2616', label: 'Motu School (2616)' },
    { value: '2617', label: 'Muriwai School (2617)' },
    { value: '2618', label: 'Napier Central School (2618)' },
    { value: '2619', label: 'Napier Intermediate (2619)' },
    { value: '2620', label: 'Nelson Park School (2620)' },
    { value: '2621', label: 'Ngatapa School (2621)' },
    { value: '2622', label: 'Norsewood and Districts School (2622)' },
    { value: '2624', label: 'Nuhaka School (2624)' },
    { value: '2625', label: 'Ohuka School (2625)' },
    { value: '2626', label: 'Omahu School (2626)' },
    { value: '2627', label: 'Omakere School (2627)' },
    { value: '2628', label: 'Onekawa School (2628)' },
    { value: '2629', label: 'Ongaonga School (2629)' },
    { value: '2631', label: 'Ormond School (2631)' },
    { value: '2634', label: 'Otane School (2634)' },
    { value: '2637', label: 'Te Kura o Pakipaki (2637)' },
    { value: '2638', label: 'Pakowhai School (2638)' },
    { value: '2641', label: 'Parkvale School (2641)' },
    { value: '2642', label: 'Patoka School (2642)' },
    { value: '2643', label: 'Patutahi School (2643)' },
    { value: '2644', label: 'Te Whai Hiringa (2644)' },
    { value: '2647', label: 'Porritt School (2647)' },
    { value: '2648', label: 'Port Ahuriri School (2648)' },
    { value: '2649', label: 'Potaka School (2649)' },
    { value: '2650', label: 'Poukawa School (2650)' },
    { value: '2651', label: 'Pukehamoamoa School (2651)' },
    { value: '2652', label: 'Pukehou School (2652)' },
    { value: '2654', label: 'Puketapu School (Hawkes Bay) (2654)' },
    { value: '2657', label: 'Putere School (2657)' },
    { value: '2658', label: 'Putorino School (2658)' },
    { value: '2659', label: 'TKKM o Tapere-Nui-A-Whatonga (2659)' },
    { value: '2662', label: 'Raureka School (2662)' },
    { value: '2663', label: 'Reignier Catholic School (2663)' },
    { value: '2664', label: 'Rere School (2664)' },
    { value: '2665', label: 'Richmond School (Napier) (2665)' },
    { value: '2667', label: 'Riverdale School (Gisborne) (2667)' },
    { value: '2669', label: 'Ruahine School (2669)' },
    { value: '2672', label: 'Sherenden and Districts School (2672)' },
    { value: '2673', label: 'Sherwood School (Hawkes Bay) (2673)' },
    { value: '2676', label: "St Joseph's School (Dannevirke) (2676)" },
    { value: '2677', label: "St Joseph's School (Hastings) (2677)" },
    { value: '2678', label: "St Joseph's School (Central Hawke's Bay) (2678)" },
    { value: '2679', label: "St Joseph's School (Wairoa) (2679)" },
    { value: '2680', label: "St Mary's Catholic School (Gisborne) (2680)" },
    { value: '2681', label: "St Mary's Catholic School (Hastings) (2681)" },
    { value: '2684', label: 'Takapau School (2684)' },
    { value: '2685', label: 'Tamatea Intermediate (2685)' },
    { value: '2686', label: 'Tamatea School (2686)' },
    { value: '2687', label: 'Taradale Intermediate (2687)' },
    { value: '2688', label: 'Taradale School (2688)' },
    { value: '2691', label: 'Te Awa School (2691)' },
    { value: '2692', label: 'Te Hapara School (2692)' },
    { value: '2697', label: 'Te Mata School (Havelock North) (2697)' },
    { value: '2698', label: 'Te Pohue School (2698)' },
    { value: '2701', label: 'Te Wharau School (Gisborne) (2701)' },
    { value: '2702', label: 'The Terrace School (Waipukurau) (2702)' },
    { value: '2703', label: 'Tikitiki School (2703)' },
    { value: '2704', label: 'Tikokino School (2704)' },
    { value: '2705', label: 'Tiniroto School (2705)' },
    { value: '2706', label: 'Hatea-A-Rangi (2706)' },
    { value: '2710', label: 'Tutira School (2710)' },
    { value: '2711', label: 'Twyford School (2711)' },
    { value: '2712', label: 'Waerenga-O-Kuri School (2712)' },
    { value: '2715', label: 'Waikirikiri School (2715)' },
    { value: '2718', label: 'Waimarama School (2718)' },
    { value: '2721', label: 'Wainui Beach School (2721)' },
    { value: '2723', label: 'Waipawa School (2723)' },
    { value: '2725', label: 'Waipukurau School (2725)' },
    { value: '2732', label: 'Weber School (2732)' },
    { value: '2733', label: 'Westshore School (2733)' },
    { value: '2736', label: 'Whangara School (2736)' },
    { value: '2739', label: 'Te Kura Kaupapa Maori o Whatatutu (2739)' },
    { value: '2742', label: 'Woodville School (2742)' },
    { value: '2745', label: "St Patrick's School (Napier) (2745)" },
    { value: '2746', label: 'Te Kura o Kimi Ora (2746)' },
    { value: '2747', label: "Hawke's Bay School for Teenage Parents (2747)" },
    { value: '2748', label: 'Karanga Mai Young Parents College (2748)' },
    { value: '2749', label: 'Te Whare Whai Hua Teenage Parent Centre (2749)' },
    { value: '2750', label: 'Puawānanga Wairarapa Young Parents (2750)' },
    { value: '2751', label: 'Te Whakatipuranga (Otumoetai TPU) (2751)' },
    { value: '2752', label: 'He Huarahi Tamariki (2752)' },
    { value: '2753', label: 'Te Āhuru Mōwai (2753)' },
    { value: '2754', label: 'Stratford High School Teen Parent Unit (2754)' },
    { value: '2755', label: 'Titiro Whakamua (2755)' },
    { value: '2756', label: 'Whakatipuria Teen Parent Unit (2756)' },
    { value: '2757', label: 'He Mataariki School for Teen Parents (2757)' },
    { value: '2758', label: 'Kawerau Teen Parent Unit (2758)' },
    { value: '2759', label: 'He Puaawai Teen Parent Unit (2759)' },
    { value: '2760', label: 'Eden Campus (2760)' },
    { value: '2761', label: "Kimihia Parents' College (2761)" },
    { value: '2762', label: 'Clendon Teen Parent Unit (2762)' },
    { value: '2801', label: 'Alfredton School (2801)' },
    { value: '2802', label: 'Arakura School (2802)' },
    { value: '2803', label: 'Avalon School (2803)' },
    { value: '2805', label: 'Ballance School (2805)' },
    { value: '2806', label: 'Bellevue School (Newlands) (2806)' },
    { value: '2807', label: 'Belmont School (Lower Hutt) (2807)' },
    { value: '2808', label: 'Berhampore School (2808)' },
    { value: '2810', label: 'Birchville School (2810)' },
    { value: '2811', label: 'Blenheim School (2811)' },
    { value: '2812', label: 'Bohally Intermediate (2812)' },
    { value: '2813', label: 'Boulcott School (2813)' },
    { value: '2814', label: 'Brandon Intermediate (2814)' },
    { value: '2816', label: 'Brooklyn School (Wellington) (2816)' },
    { value: '2818', label: 'Cannons Creek School (2818)' },
    { value: '2820', label: 'Carterton School (2820)' },
    { value: '2821', label: 'Cashmere Avenue School (2821)' },
    { value: '2823', label: 'Crofton Downs Primary School (2823)' },
    { value: '2824', label: 'Churton Park School (2824)' },
    { value: '2826', label: 'Clifton Terrace Model School (2826)' },
    { value: '2827', label: 'Clyde Quay School (2827)' },
    { value: '2828', label: 'Corinna School (2828)' },
    { value: '2831', label: 'Dalefield School (2831)' },
    { value: '2832', label: 'Discovery School (2832)' },
    { value: '2833', label: 'Dyer Street School (2833)' },
    { value: '2834', label: 'Eastern Hutt School (2834)' },
    { value: '2835', label: 'Eketāhuna School (2835)' },
    { value: '2836', label: 'Epuni School (2836)' },
    { value: '2837', label: 'Evans Bay Intermediate (2837)' },
    { value: '2838', label: 'Fairfield School (Levin) (2838)' },
    { value: '2839', label: 'Fairhall School (2839)' },
    { value: '2840', label: 'Featherston School Te Kura o Paetūmokai (2840)' },
    { value: '2841', label: 'Fergusson Intermediate (Trentham) (2841)' },
    { value: '2842', label: 'Fernlea School (2842)' },
    { value: '2843', label: 'Fernridge School (2843)' },
    { value: '2844', label: 'Fraser Crescent School (2844)' },
    { value: '2845', label: 'Gladstone School (Masterton) (2845)' },
    { value: '2846', label: 'Pukeatua Primary School (Wainuiomata) (2846)' },
    { value: '2847', label: 'Glenview School (Porirua East) (2847)' },
    { value: '2848', label: 'Gracefield School (2848)' },
    { value: '2849', label: 'Greenacres School (2849)' },
    { value: '2850', label: 'Greytown School (2850)' },
    { value: '2851', label: 'Grovetown School (2851)' },
    { value: '2852', label: 'Hampton Hill School (2852)' },
    { value: '2854', label: 'Hataitai School (2854)' },
    { value: '2855', label: 'Havelock School (2855)' },
    { value: '2859', label: 'Holy Family School (Porirua) (2859)' },
    { value: '2861', label: 'Houghton Valley School (2861)' },
    { value: '2862', label: 'Hutt Central School (2862)' },
    { value: '2863', label: 'Hutt Intermediate (2863)' },
    { value: '2865', label: 'Island Bay School (2865)' },
    { value: '2866', label: 'Johnsonville School (2866)' },
    { value: '2867', label: 'West Park School (2867)' },
    { value: '2868', label: 'Kahutara School (2868)' },
    { value: '2871', label: 'Kapakapanui School (2871)' },
    {
      value: '2872',
      label: 'Mahinawa Specialist School and Resource Centre (2872)',
    },
    { value: '2873', label: 'Kapiti School (2873)' },
    { value: '2874', label: 'Karori Normal School (2874)' },
    { value: '2875', label: 'Karori West Normal School (2875)' },
    { value: '2876', label: 'Kelburn Normal School (2876)' },
    { value: '2877', label: 'Kelson School (2877)' },
    { value: '2878', label: 'Kenakena School (2878)' },
    { value: '2879', label: 'Khandallah School (2879)' },
    { value: '2880', label: 'Kilbirnie School (2880)' },
    { value: '2882', label: 'Koputaroa School (2882)' },
    { value: '2883', label: 'Korokoro School (2883)' },
    { value: '2886', label: 'Levin East School (2886)' },
    { value: '2887', label: 'Levin Intermediate (2887)' },
    { value: '2888', label: 'Levin North School (2888)' },
    { value: '2889', label: 'Levin School (2889)' },
    { value: '2890', label: 'Linden School (2890)' },
    { value: '2891', label: 'Linkwater School (2891)' },
    { value: '2892', label: 'Lyall Bay School (2892)' },
    { value: '2893', label: 'Maidstone Intermediate (2893)' },
    { value: '2894', label: 'Mākara Model School (2894)' },
    { value: '2895', label: 'Makuri School (2895)' },
    { value: '2896', label: 'Manakau School (2896)' },
    { value: '2899', label: 'Mangaroa School (2899)' },
    { value: '2900', label: 'Mangatainoka School (2900)' },
    { value: '2902', label: 'Te Kura o Hau Karetu (2902)' },
    { value: '2903', label: 'Maraeroa School (2903)' },
    { value: '2904', label: 'Holy Cross School (Miramar) (2904)' },
    { value: '2906', label: 'Martinborough School (2906)' },
    { value: '2909', label: 'Masterton Intermediate (2909)' },
    { value: '2911', label: 'Mauriceville School (2911)' },
    { value: '2912', label: 'Mayfield School (Blenheim) (2912)' },
    { value: '2915', label: 'Miramar Central School (2915)' },
    { value: '2916', label: 'Miramar North School (2916)' },
    { value: '2918', label: 'Mt Cook School (Wellington) (2918)' },
    { value: '2920', label: 'Muritai School (2920)' },
    { value: '2921', label: 'Naenae Intermediate (2921)' },
    { value: '2922', label: 'Naenae School (2922)' },
    { value: '2923', label: 'Natone Park School (2923)' },
    { value: '2924', label: 'Newlands Intermediate (2924)' },
    { value: '2925', label: 'Newlands School (2925)' },
    { value: '2926', label: 'Newtown School (2926)' },
    { value: '2927', label: 'Ngaio School (2927)' },
    { value: '2928', label: 'Ngati Toa School (2928)' },
    { value: '2930', label: 'Normandale School (2930)' },
    { value: '2931', label: 'Northland School (2931)' },
    { value: '2933', label: 'Ohau School (2933)' },
    { value: '2936', label: 'Ōpaki School (2936)' },
    { value: '2937', label: 'Opiki School (2937)' },
    { value: '2939', label: 'Otaki School (2939)' },
    { value: '2941', label: 'Our Lady of the Rosary School (Waiwhetu) (2941)' },
    { value: '2942', label: 'Owhiro Bay School (2942)' },
    { value: '2943', label: 'Oxford Crescent School (2943)' },
    { value: '2944', label: 'Paekākāriki School (2944)' },
    { value: '2945', label: 'Pahiatua School (2945)' },
    { value: '2946', label: 'Papakowhai School (2946)' },
    { value: '2947', label: 'Paparangi School (2947)' },
    { value: '2948', label: 'Paraparaumu Beach School (2948)' },
    { value: '2949', label: 'Paraparaumu School (2949)' },
    { value: '2950', label: 'Paremata School (2950)' },
    { value: '2953', label: 'Pauatahanui School (2953)' },
    { value: '2955', label: 'Petone Central School (2955)' },
    { value: '2956', label: 'Picton School (2956)' },
    { value: '2957', label: 'Pinehaven School (2957)' },
    { value: '2958', label: 'Pirinoa School (2958)' },
    { value: '2959', label: 'Plateau School (2959)' },
    { value: '2960', label: 'Plimmerton School (2960)' },
    { value: '2961', label: 'Pomare School (2961)' },
    { value: '2962', label: 'Pongaroa School (2962)' },
    { value: '2963', label: 'Porirua East School (2963)' },
    { value: '2964', label: 'Porirua School (2964)' },
    { value: '2965', label: 'Poroutawhao School (2965)' },
    { value: '2966', label: 'Postgate School (2966)' },
    { value: '2967', label: 'Pukerua Bay School (2967)' },
    { value: '2968', label: 'Maungaraki School (2968)' },
    { value: '2969', label: 'Randwick School (2969)' },
    { value: '2970', label: 'Rangikura School (2970)' },
    { value: '2971', label: 'Rapaura School (2971)' },
    { value: '2972', label: 'Raroa Normal Intermediate (2972)' },
    { value: '2973', label: 'Rata Street School (2973)' },
    { value: '2974', label: 'Raumati Beach School (2974)' },
    { value: '2975', label: 'Raumati South School (2975)' },
    { value: '2976', label: 'Redwood School (Tawa) (2976)' },
    { value: '2977', label: 'Redwoodtown School (2977)' },
    { value: '2978', label: 'Renwick School (2978)' },
    { value: '2979', label: 'Rewa Rewa School (2979)' },
    { value: '2980', label: 'Te Kura o Tawatawa - Ridgway School (2980)' },
    { value: '2981', label: 'Riverlands School (2981)' },
    { value: '2982', label: 'Roseneath School (2982)' },
    { value: '2983', label: 'Russell School (Porirua East) (2983)' },
    { value: '2984', label: 'Sacred Heart School (Petone) (2984)' },
    { value: '2985', label: 'Sacred Heart Cathedral School (2985)' },
    { value: '2987', label: 'Seatoun School (2987)' },
    { value: '2988', label: 'Seddon School (2988)' },
    { value: '2989', label: 'Shannon School (2989)' },
    { value: '2990', label: 'Silverstream School (2990)' },
    { value: '2991', label: 'Solway School (2991)' },
    { value: '2992', label: 'South End School (2992)' },
    { value: '2993', label: 'South Featherston School (2993)' },
    { value: '2994', label: 'South Wellington Intermediate (2994)' },
    { value: '2995', label: 'Spring Creek School (2995)' },
    { value: '2996', label: 'Springlands School (2996)' },
    { value: '2997', label: 'St Annes School (Newtown) (2997)' },
    { value: '2998', label: "St Anthony's School (Pahiatua) (2998)" },
    { value: '2999', label: "St Anthony's School (Seatoun) (2999)" },
    { value: '3000', label: "St Benedict's School (Khandallah) (3000)" },
    { value: '3001', label: "St Bernadette's School (Naenae) (3001)" },
    { value: '3004', label: "St Brendan's School (Heretaunga) (3004)" },
    { value: '3005', label: 'St Brigids School (Johnsonville) (3005)' },
    { value: '3006', label: 'St Francis De Sales School (Is Bay) (3006)' },
    { value: '3007', label: 'St Francis Xavier School (Tawa) (3007)' },
    { value: '3008', label: "St Joseph's School (Levin) (3008)" },
    { value: '3011', label: "St Joseph's School (Upper Hutt) (3011)" },
    { value: '3012', label: "St Mary's School (Blenheim) (3012)" },
    { value: '3013', label: "St Mary's School (Carterton) (3013)" },
    { value: '3015', label: "St Michael's School (Taita) (3015)" },
    { value: '3016', label: "St Patrick's School (Masterton) (3016)" },
    { value: '3017', label: 'Our Lady of Kapiti School (3017)' },
    { value: '3018', label: 'St Claudine Thevenet School (3018)' },
    { value: '3019', label: "St Patrick's School (Kilbirnie) (3019)" },
    { value: '3020', label: 'St Peter Chanel School (Otaki) (3020)' },
    { value: '3021', label: 'Sts Peter and Paul School (L Hutt) (3021)' },
    { value: '3022', label: 'St Pius X School (Titahi Bay) (3022)' },
    { value: '3023', label: "St Teresa's School (Featherston) (3023)" },
    { value: '3024', label: "St Teresa's School (Karori) (3024)" },
    { value: '3025', label: "St Theresa's School (Plimmerton) (3025)" },
    { value: '3029', label: 'Tairangi School (3029)' },
    { value: '3030', label: 'Taita Central School (3030)' },
    { value: '3031', label: 'Avalon Intermediate (3031)' },
    { value: '3032', label: 'Taitoko School (3032)' },
    { value: '3034', label: 'Tawa Intermediate (3034)' },
    { value: '3035', label: 'Tawa School (3035)' },
    { value: '3036', label: 'Tawhai School (3036)' },
    { value: '3037', label: 'Te Aro School (3037)' },
    { value: '3038', label: 'Te Horo School (Otaki) (3038)' },
    { value: '3040', label: 'Thorndon School (3040)' },
    { value: '3041', label: 'Tinui School (3041)' },
    { value: '3043', label: 'Titahi Bay Intermediate (3043)' },
    { value: '3044', label: 'Titahi Bay North School (3044)' },
    { value: '3045', label: 'Titahi Bay School (3045)' },
    { value: '3046', label: 'Tokomaru School (3046)' },
    { value: '3048', label: 'Totara Park School (3048)' },
    { value: '3050', label: 'Tua Marina School (3050)' },
    { value: '3051', label: 'Tui Glen School (3051)' },
    { value: '3053', label: 'Upper Hutt School (3053)' },
    { value: '3055', label: 'Wadestown School (3055)' },
    { value: '3056', label: 'Waikanae School (3056)' },
    { value: '3057', label: 'Waikawa Bay School (3057)' },
    { value: '3059', label: 'Wainuiomata Primary School (3059)' },
    { value: '3060', label: 'Wainuioru School (3060)' },
    { value: '3062', label: 'Wairau Valley School (Blenheim) (3062)' },
    { value: '3064', label: 'Waitaria Bay School (3064)' },
    { value: '3065', label: 'Waitohu School (3065)' },
    { value: '3067', label: 'Ward School (3067)' },
    { value: '3068', label: 'Waterloo School (3068)' },
    { value: '3070', label: 'Whareama School (3070)' },
    { value: '3071', label: 'Whitney Street School (3071)' },
    { value: '3072', label: 'Wilford School (3072)' },
    { value: '3073', label: 'Ōtari School (3073)' },
    { value: '3074', label: 'Windley School (3074)' },
    { value: '3075', label: 'Witherlea School (3075)' },
    { value: '3077', label: 'Worser Bay School (3077)' },
    { value: '3100', label: 'TKKM o Te Hiringa (3100)' },
    { value: '3101', label: 'Te Kura ā Iwi o Whakatupuranga Rua Mano (3101)' },
    { value: '3102', label: 'TKKM o Waiuku (3102)' },
    { value: '3103', label: 'TKKM o Hurungaterangi (3103)' },
    { value: '3104', label: 'TKKM o Te Kotuku (3104)' },
    { value: '3106', label: 'TKKM o Whangaroa (3106)' },
    { value: '3107', label: 'TKKM o Te Ara Hou (3107)' },
    { value: '3113', label: 'Te Wharekura o Manurewa (3113)' },
    { value: '3114', label: 'TKKM o Pukemiro (3114)' },
    { value: '3115', label: 'Te Wharekura o Te Rau Aroha (3115)' },
    { value: '3117', label: 'Te Kura Kaupapa Māori o Hokianga (3117)' },
    { value: '3118', label: 'Te Kura Kaupapa Maori o Taumarunui (3118)' },
    { value: '3119', label: 'TKKM o Kawakawa mai Tawhiti (3119)' },
    { value: '3180', label: 'Appleby School (3180)' },
    { value: '3181', label: 'Auckland Point School (3181)' },
    { value: '3182', label: 'Birchwood School (3182)' },
    { value: '3183', label: 'Brightwater School (3183)' },
    { value: '3184', label: 'Broadgreen Intermediate (3184)' },
    { value: '3185', label: 'Brooklyn School (Motueka) (3185)' },
    { value: '3186', label: 'Canvastown School (3186)' },
    { value: '3187', label: 'Clifton Terrace School (3187)' },
    { value: '3188', label: 'Dovedale School (3188)' },
    { value: '3189', label: 'Enner Glynn School (3189)' },
    { value: '3192', label: 'Granity School (3192)' },
    { value: '3193', label: 'Hampden Street School (3193)' },
    { value: '3194', label: 'Henley School (Nelson) (3194)' },
    { value: '3195', label: 'Hira School (3195)' },
    { value: '3196', label: 'Hope School (3196)' },
    { value: '3199', label: 'Lake Rotoiti School (3199)' },
    { value: '3200', label: 'Lower Moutere School (3200)' },
    { value: '3201', label: 'Mahana School (3201)' },
    { value: '3202', label: 'Maitai School (3202)' },
    { value: '3203', label: 'Mapua School (3203)' },
    { value: '3204', label: 'Maruia School (3204)' },
    { value: '3206', label: 'Motueka South School (3206)' },
    { value: '3207', label: 'Motupipi School (3207)' },
    { value: '3208', label: 'Nayland Primary School (3208)' },
    { value: '3209', label: 'Nelson Central School (3209)' },
    { value: '3210', label: 'Nelson Intermediate (3210)' },
    { value: '3212', label: 'Ngatimoti School (3212)' },
    { value: '3213', label: 'Parklands School (Motueka) (3213)' },
    { value: '3214', label: 'Ranzau School (3214)' },
    { value: '3216', label: 'Richmond School (Nelson) (3216)' },
    { value: '3217', label: 'Riwaka School (3217)' },
    { value: '3219', label: 'Sacred Heart School (Reefton) (3219)' },
    { value: '3220', label: "St Canice's School (Westport) (3220)" },
    { value: '3221', label: "St Joseph's School (Nelson) (3221)" },
    { value: '3222', label: 'St Peter Chanel School (Motueka) (3222)' },
    { value: '3223', label: 'Stoke School (3223)' },
    { value: '3224', label: 'Tahunanui School (3224)' },
    { value: '3225', label: 'Central Takaka School (3225)' },
    { value: '3226', label: 'Takaka Primary School (3226)' },
    { value: '3228', label: 'Tasman School (3228)' },
    { value: '3229', label: 'Upper Moutere School (3229)' },
    { value: '3231', label: 'Victory Primary School (3231)' },
    { value: '3233', label: 'Waimea Intermediate (3233)' },
    { value: '3234', label: 'Wakefield School (3234)' },
    { value: '3235', label: 'Westport North School (3235)' },
    { value: '3236', label: 'Westport South School (3236)' },
    { value: '3270', label: 'Sacred Heart School (Christchurch) (3270)' },
    { value: '3271', label: 'Addington Te Kura Taumatua (3271)' },
    { value: '3273', label: 'Albury School (3273)' },
    { value: '3274', label: 'Allenton School (3274)' },
    { value: '3275', label: 'Pītau-Allenvale School (3275)' },
    { value: '3276', label: 'Amberley School (3276)' },
    { value: '3280', label: 'Arowhenua Maori School (3280)' },
    { value: '3281', label: 'Ashburton Borough School (3281)' },
    { value: '3282', label: 'Ashburton Intermediate (3282)' },
    { value: '3283', label: 'Ashburton Netherby School (3283)' },
    { value: '3284', label: 'Tūtira Ashgrove School (3284)' },
    { value: '3285', label: 'Ashley Rakahuri School (3285)' },
    { value: '3287', label: 'Avonhead School - Rakipaoa (3287)' },
    { value: '3288', label: 'Ngutuawa School (3288)' },
    { value: '3289', label: 'Pareawa Banks Avenue School (3289)' },
    { value: '3290', label: 'Barrytown School (3290)' },
    { value: '3291', label: 'Beckenham Te Kura o Pūroto (3291)' },
    { value: '3292', label: 'Pūtahi Belfast School (3292)' },
    { value: '3293', label: 'Bishopdale School Te Kura o Papakōhatu (3293)' },
    { value: '3295', label: 'Blaketown School (3295)' },
    { value: '3299', label: 'Breens Intermediate (3299)' },
    { value: '3301', label: 'Broadfield School (3301)' },
    { value: '3302', label: 'Te Ahuwai Bromley School (3302)' },
    { value: '3303', label: 'Broomfield School (3303)' },
    { value: '3304', label: 'Burnham School - Te Kura o Tiori (3304)' },
    { value: '3305', label: 'Tuia Burnside Primary School (3305)' },
    { value: '3307', label: 'Cannington School (3307)' },
    { value: '3308', label: 'Carew Peel Forest School (3308)' },
    { value: '3309', label: 'Casebrook Intermediate (3309)' },
    { value: '3310', label: 'Cashmere Primary Te Pae Kererū (3310)' },
    { value: '3313', label: 'Chertsey School (3313)' },
    { value: '3314', label: 'Chisnallwood Intermediate (3314)' },
    { value: '3316', label: 'Christ The King School (Burnside) (3316)' },
    { value: '3317', label: 'Christchurch East School (3317)' },
    {
      value: '3318',
      label: 'Christchurch South Karamata Intermediate School (3318)',
    },
    { value: '3321', label: 'Clarkville Te Kura ki Waimātao (3321)' },
    { value: '3322', label: 'Cobden School (3322)' },
    { value: '3323', label: 'Wairarapa Cobham Intermediate (3323)' },
    { value: '3324', label: 'Cotswold Mātāhae School (3324)' },
    { value: '3325', label: 'Cust School (3325)' },
    { value: '3326', label: 'Darfield School (3326)' },
    { value: '3327', label: 'Diamond Harbour School (3327)' },
    { value: '3329', label: 'Dorie School (3329)' },
    { value: '3331', label: 'Dunsandel School (3331)' },
    { value: '3332', label: 'Duvauchelle School (3332)' },
    { value: '3334', label: 'Elmwood Normal School (3334)' },
    { value: '3335', label: 'Fairlie School (3335)' },
    { value: '3336', label: 'Fairton School (3336)' },
    { value: '3338', label: 'Tūora Fendalton School (3338)' },
    { value: '3339', label: 'Ferndale Te Ahu (3339)' },
    { value: '3340', label: 'Fernside School (3340)' },
    { value: '3342', label: 'Fox Glacier School (3342)' },
    { value: '3343', label: 'Franz Josef Glacier School (3343)' },
    { value: '3346', label: 'Gilberthorpe School (3346)' },
    { value: '3347', label: 'Gleniti School (3347)' },
    { value: '3348', label: 'Glenavy School (3348)' },
    { value: '3352', label: 'Glentunnel School (3352)' },
    { value: '3354', label: 'Te Kura o Ōhinetahi - Governors Bay (3354)' },
    { value: '3357', label: 'Greendale School (3357)' },
    { value: '3359', label: 'Greta Valley School (3359)' },
    { value: '3361', label: 'Greymouth Main School (3361)' },
    { value: '3363', label: 'Haast School (3363)' },
    { value: '3366', label: 'Te Kura o te Tauawa Halswell School (3366)' },
    { value: '3367', label: 'Hampstead School (3367)' },
    { value: '3368', label: 'Hanmer Springs School (3368)' },
    { value: '3369', label: 'Hāpuku School (3369)' },
    { value: '3370', label: 'Harewood School (3370)' },
    { value: '3371', label: 'Heathcote Valley School (3371)' },
    {
      value: '3372',
      label: 'He Tīwai Mātauranga Heaton Normal Intermediate (3372)',
    },
    { value: '3373', label: 'Highfield School (3373)' },
    { value: '3375', label: 'Hinds School (3375)' },
    { value: '3376', label: 'Hokitika Primary School (3376)' },
    { value: '3379', label: 'Hoon Hay Te Kura Kōaka (3379)' },
    { value: '3380', label: 'Hornby Primary School (3380)' },
    { value: '3381', label: 'Hororata School (3381)' },
    { value: '3384', label: 'Ilam School (3384)' },
    { value: '3385', label: 'Te Kura o Te Mātāpuna Isleworth School (3385)' },
    { value: '3387', label: 'Kaingaroa School (Chatham Islands) (3387)' },
    { value: '3388', label: 'Kaiapoi Borough School (3388)' },
    { value: '3389', label: 'Kaiapoi North School (3389)' },
    { value: '3391', label: 'Kaikōura Primary School (3391)' },
    { value: '3392', label: 'Kaikōura Suburban School (3392)' },
    { value: '3393', label: 'Kaniere School (3393)' },
    { value: '3394', label: 'Karoro School (3394)' },
    { value: '3396', label: 'Kahikatea Kirkwood Intermediate (3396)' },
    { value: '3397', label: 'Kirwee Model School (3397)' },
    { value: '3398', label: 'Kokatahi-Kowhitirangi School (3398)' },
    { value: '3401', label: 'Kumara School (3401)' },
    { value: '3402', label: 'Ladbrooks School (3402)' },
    { value: '3406', label: 'Lake Tekapo School (3406)' },
    { value: '3407', label: 'Lauriston School (3407)' },
    { value: '3410', label: 'Leeston School (3410)' },
    { value: '3411', label: 'Leithfield School Te Kura o Kōwai (3411)' },
    { value: '3412', label: 'Lincoln Primary School (3412)' },
    { value: '3413', label: 'Te Huarahi Linwood Avenue School  (3413)' },
    { value: '3415', label: 'Whītau School (3415)' },
    { value: '3418', label: 'Little River School (3418)' },
    { value: '3419', label: 'Loburn School Te Kura Aromauka (3419)' },
    { value: '3425', label: 'Mairehau Primary School (3425)' },
    { value: '3426', label: 'Makikihi School (3426)' },
    { value: '3429', label: 'Marshland School (3429)' },
    { value: '3432', label: 'Mayfield School (Mid-Canterbury) (3432)' },
    { value: '3434', label: 'Merrin School Ngā Whetū Kohara (3434)' },
    { value: '3436', label: 'Methven Primary School (3436)' },
    { value: '3441', label: 'Mt Somers Springburn School (3441)' },
    { value: '3442', label: 'Aoraki Mount Cook School (3442)' },
    { value: '3443', label: 'Mt Pleasant School (3443)' },
    { value: '3445', label: 'New Brighton Catholic School (Chch) (3445)' },
    { value: '3447', label: 'North Loburn School (3447)' },
    { value: '3449', label: 'Te Kura o Matarangi - Northcote School (3449)' },
    { value: '3450', label: 'Oaklands Te Kura o Ōwaka (3450)' },
    { value: '3451', label: 'Ōhoka School (3451)' },
    { value: '3452', label: 'Okains Bay School (3452)' },
    { value: '3454', label: 'Omihi School (3454)' },
    { value: '3455', label: 'Te Kura o Ōpāwaho – Opawa School (3455)' },
    { value: '3461', label: 'Our Lady of the Assumption School (Chch) (3461)' },
    { value: '3462', label: 'Our Lady of the Snows School (Methven) (3462)' },
    { value: '3463', label: 'Our Lady of Victories (3463)' },
    { value: '3464', label: 'Ōuruhia Model School (3464)' },
    { value: '3466', label: 'Papanui Primary School (3466)' },
    { value: '3467', label: 'Paparoa Street School (3467)' },
    { value: '3470', label: 'Parkview Pārua (3470)' },
    { value: '3472', label: 'Paroa School (Greymouth) (3472)' },
    { value: '3476', label: 'Pitt Island School (3476)' },
    { value: '3477', label: 'Pleasant Point Primary School (3477)' },
    { value: '3478', label: 'Prebbleton School (3478)' },
    { value: '3479', label: 'Queenspark Te Hua Mānuka (3479)' },
    { value: '3480', label: 'Rakaia School (3480)' },
    { value: '3481', label: 'Rangiora Borough School (3481)' },
    { value: '3483', label: 'Te Raekura Redcliffs School (3483)' },
    { value: '3484', label: 'Redwood School (Christchurch) (3484)' },
    { value: '3485', label: 'Te Kāpehu Riccarton School (3485)' },
    { value: '3488', label: 'Rolleston School (3488)' },
    { value: '3489', label: 'Ross School (3489)' },
    { value: '3490', label: 'Rotherham School (3490)' },
    { value: '3492', label: 'Te Kōmanawa Rowley School (3492)' },
    { value: '3493', label: 'Te Ara Maurea Roydvale School (3493)' },
    { value: '3495', label: 'Runanga School (3495)' },
    { value: '3496', label: 'Te Parito Kōwhai Russley School (3496)' },
    { value: '3498', label: 'Sacred Heart School (Timaru) (3498)' },
    { value: '3501', label: 'Te Waitai Sefton School (3501)' },
    { value: '3502', label: 'Sheffield Contributing School (3502)' },
    { value: '3503', label: 'Te Oraka (3503)' },
    { value: '3504', label: 'Te Hiwa Shirley Primary School (3504)' },
    { value: '3505', label: 'Wigram Primary School - Te Piki Kāhu (3505)' },
    { value: '3506', label: 'Somerfield Te Kura Wairepo (3506)' },
    { value: '3507', label: 'Te Manu Tukutuku South Hornby School (3507)' },
    { value: '3508', label: 'South New Brighton School (3508)' },
    { value: '3509', label: 'Southbridge School (3509)' },
    { value: '3510', label: 'Southbrook School (3510)' },
    { value: '3512', label: 'Te Kura o Mōkihi Spreydon School (3512)' },
    { value: '3515', label: 'Springfield School (3515)' },
    { value: '3516', label: 'Springston School (3516)' },
    { value: '3517', label: 'St Albans Catholic School (Christchurch) (3517)' },
    { value: '3518', label: 'St Albans School (3518)' },
    { value: '3519', label: "St Andrew's School (Timaru) (3519)" },
    { value: '3520', label: "St Anne's School (Woolston) (3520)" },
    { value: '3521', label: "St Bernadette's School (Hornby) (3521)" },
    { value: '3523', label: 'St James School (Aranui) (3523)' },
    { value: '3527', label: "St Joseph's School (Ashburton) (3527)" },
    { value: '3528', label: "St Joseph's School (Pleasant Point) (3528)" },
    { value: '3529', label: "St Joseph's School (Fairlie) (3529)" },
    { value: '3530', label: 'St Joseph’s School (Kaikōura) (3530)' },
    { value: '3531', label: "St Joseph's School (Papanui) (3531)" },
    { value: '3532', label: "St Joseph's School (Temuka) (3532)" },
    { value: '3533', label: "St Joseph's School (Timaru) (3533)" },
    { value: '3534', label: 'St Martins School (3534)' },
    { value: '3535', label: "St Mary's School (Christchurch) (3535)" },
    { value: '3536', label: "St Mary's School (Hokitika) (3536)" },
    { value: '3537', label: "St Patrick's School (Bryndwr) (3537)" },
    { value: '3538', label: "St Patrick's School (Greymouth) (3538)" },
    { value: '3539', label: "St Patrick's School (Waimate) (3539)" },
    { value: '3540', label: "St Patrick's School (Kaiapoi) (3540)" },
    { value: '3542', label: "St Peter's School Te Kura Haoika   (3542)" },
    { value: '3543', label: "St Teresa's School (Riccarton) (3543)" },
    {
      value: '3544',
      label: 'Our Lady Star of the Sea School (Christchurch) (3544)',
    },
    { value: '3546', label: 'Sumner School (3546)' },
    { value: '3547', label: 'Te Koromiko Swannanoa School (3547)' },
    { value: '3549', label: 'Tai Tapu School (3549)' },
    { value: '3553', label: 'Te One School (3553)' },
    { value: '3554', label: 'Waitaha School (3554)' },
    { value: '3555', label: 'Templeton School (3555)' },
    { value: '3557', label: 'Te Kura o Huriawa Thorrington (3557)' },
    { value: '3561', label: 'Tinwald School (3561)' },
    { value: '3563', label: 'Te Kura o Tuahiwi (3563)' },
    { value: '3565', label: 'View Hill School (3565)' },
    { value: '3566', label: 'Waiau School (3566)' },
    { value: '3567', label: 'Waihao Downs School (3567)' },
    { value: '3569', label: 'Waikari School (3569)' },
    { value: '3570', label: 'Pegasus Bay School (3570)' },
    { value: '3571', label: 'Waimairi School (3571)' },
    { value: '3572', label: 'Waimataitai School (3572)' },
    { value: '3573', label: 'Waimate Centennial School (3573)' },
    { value: '3574', label: 'Waimate Main School (3574)' },
    { value: '3576', label: 'Waipara School (3576)' },
    { value: '3577', label: 'Wairakei School (Christchurch) (3577)' },
    { value: '3579', label: 'Waituna Creek School (3579)' },
    { value: '3580', label: 'Wakanui School (3580)' },
    { value: '3581', label: 'Waltham School (3581)' },
    { value: '3585', label: 'Weedons School (3585)' },
    { value: '3586', label: 'West Eyreton School (3586)' },
    { value: '3587', label: 'West Melton School (3587)' },
    { value: '3588', label: 'Te Ara Koropiko West Spreydon School (3588)' },
    { value: '3589', label: 'Westburn Te Kura O Hereora (3589)' },
    { value: '3591', label: 'Wharenui School (3591)' },
    { value: '3592', label: 'Whataroa School (3592)' },
    { value: '3594', label: 'Longbeach School (3594)' },
    { value: '3597', label: 'Windwhistle School (3597)' },
    { value: '3599', label: 'Woodbury School (3599)' },
    { value: '3600', label: 'Woodend School (3600)' },
    { value: '3602', label: 'Yaldhurst School – Tōtara Tūkaha (3602)' },
    { value: '3612', label: 'Mangakōtukutuku College (3612)' },
    { value: '3617', label: 'Prebbleton New School (3617)' },
    { value: '3618', label: 'Te Kura aa Iwi o Ngaati Kauwhata (3618)' },
    { value: '3619', label: 'Te Kāpehu Whetū (3619)' },
    { value: '3620', label: 'Pinnacle Global Academy (3620)' },
    { value: '3625', label: 'Māruawai College (3625)' },
    { value: '3628', label: 'Elim Christian College Henderson (3628)' },
    { value: '3630', label: 'Elim Christian College Mt Albert (3630)' },
    { value: '3641', label: 'Porirua Montessori Primary School (3641)' },
    { value: '3645', label: 'Te Kākā Kura o Ngāti Toa Rangatira (3645)' },
    { value: '3659', label: 'Te Kura ā Iwi o Te Waimate (3659)' },
    { value: '3679', label: 'Te Kura Kaupapa Māori o Ngā Papaonekura (3679)' },
    { value: '3680', label: 'Mastery Schools New Zealand - Arapaki (3680)' },
    { value: '3681', label: 'The BUSY School NZ (3681)' },
    { value: '3682', label: 'Ecole Francaise Internationale Auckland (3682)' },
    { value: '3683', label: 'Te Rito - Te Kura Taiao (3683)' },
    { value: '3684', label: 'Christchurch North College (3684)' },
    { value: '3685', label: 'Galaxy International College (3685)' },
    { value: '3686', label: 'North West College (3686)' },
    { value: '3687', label: 'TIPENE (3687)' },
    { value: '3690', label: 'Te Pā Wānanga o Ōmaka Marae (3690)' },
    { value: '3691', label: 'Mangawhai Hills College (3691)' },
    { value: '3698', label: 'Twin Oaks Classical School (3698)' },
    { value: '3699', label: 'Totara Point School (3699)' },
    { value: '3700', label: 'Abbotsford School (3700)' },
    { value: '3701', label: 'Alexandra Primary School (3701)' },
    { value: '3703', label: 'Andersons Bay School (3703)' },
    { value: '3704', label: 'Ardgowan School (3704)' },
    { value: '3706', label: 'Arthur Street School (3706)' },
    { value: '3707', label: 'Fenwick School (3707)' },
    { value: '3709', label: 'Balaclava School (3709)' },
    { value: '3710', label: 'Balclutha School (3710)' },
    { value: '3711', label: 'Balmacewen Intermediate (3711)' },
    { value: '3716', label: 'Bradford School (3716)' },
    { value: '3718', label: 'Broad Bay School (3718)' },
    { value: '3719', label: 'Brockville School (3719)' },
    { value: '3723', label: 'Clinton School (3723)' },
    { value: '3724', label: 'Clutha Valley School (3724)' },
    { value: '3725', label: 'Clyde School (3725)' },
    { value: '3727', label: 'Concord School (3727)' },
    { value: '3729', label: 'Cromwell Primary School (3729)' },
    { value: '3731', label: 'Dunedin North Intermediate (3731)' },
    { value: '3732', label: 'Duntroon School (3732)' },
    { value: '3733', label: 'East Taieri School (3733)' },
    { value: '3736', label: 'Fairfield School (Dunedin) (3736)' },
    { value: '3737', label: 'Pembroke School (Oamaru) (3737)' },
    { value: '3738', label: 'Five Forks School (3738)' },
    { value: '3740', label: 'George Street Normal School (3740)' },
    { value: '3741', label: 'Goldfields School (Cromwell) (3741)' },
    { value: '3742', label: 'Grants Braes School (3742)' },
    { value: '3743', label: 'Green Island School (3743)' },
    { value: '3745', label: 'Halfway Bush School (3745)' },
    { value: '3746', label: 'Hampden School (3746)' },
    { value: '3747', label: 'Hāwea Flat School (3747)' },
    { value: '3749', label: 'Heriot School (3749)' },
    { value: '3753', label: 'Kaikorai School (3753)' },
    { value: '3754', label: 'Kaitangata School (3754)' },
    { value: '3755', label: 'Kakanui School (3755)' },
    { value: '3756', label: 'Karitane School (3756)' },
    { value: '3761', label: 'Lee Stream School (3761)' },
    { value: '3762', label: 'Macandrew Bay School (3762)' },
    { value: '3764', label: 'Macraes Moonlight School (3764)' },
    { value: '3765', label: 'Maheno School (3765)' },
    { value: '3767', label: 'Makarora Primary School (3767)' },
    { value: '3768', label: 'Maori Hill School (3768)' },
    { value: '3771', label: 'Millers Flat School (3771)' },
    { value: '3772', label: 'Milton School (3772)' },
    { value: '3776', label: 'Mornington School (3776)' },
    { value: '3778', label: 'Elmgrove School (3778)' },
    { value: '3779', label: 'Musselburgh School (3779)' },
    { value: '3783', label: 'North East Valley Normal School (3783)' },
    { value: '3784', label: 'Oamaru Intermediate (3784)' },
    { value: '3785', label: 'Te Pākihi o Maru (3785)' },
    { value: '3788', label: 'Omakau School (3788)' },
    { value: '3789', label: 'Omarama School (3789)' },
    { value: '3790', label: 'Ōpoho School (3790)' },
    { value: '3795', label: 'Outram School (3795)' },
    { value: '3797', label: 'Palmerston School (3797)' },
    { value: '3798', label: 'Papakaio School (3798)' },
    { value: '3801', label: 'Pine Hill School (Dunedin) (3801)' },
    { value: '3802', label: 'Poolburn School (3802)' },
    { value: '3803', label: 'Port Chalmers School (3803)' },
    { value: '3805', label: 'Portobello School (3805)' },
    { value: '3807', label: 'Pūrākaunui School (3807)' },
    { value: '3808', label: 'Ravensbourne School (3808)' },
    { value: '3811', label: 'Romahapa School (3811)' },
    { value: '3812', label: 'Rosebank School (Balclutha) (3812)' },
    { value: '3815', label: 'Sacred Heart School (Dunedin) (3815)' },
    { value: '3816', label: 'Te Whirika Sara Cohen Specialist School (3816)' },
    { value: '3817', label: 'Sawyers Bay School (3817)' },
    { value: '3819', label: "St Bernadette's School (Forbury) (3819)" },
    { value: '3820', label: 'St Brigids School (Tainui) (3820)' },
    { value: '3822', label: 'St Francis Xavier School (Mornington) (3822)' },
    { value: '3823', label: "St Gerard's School (Alexandra) (3823)" },
    { value: '3824', label: "St John's School (Ranfurly) (3824)" },
    { value: '3825', label: "St Joseph's School (Oamaru) (3825)" },
    { value: '3826', label: "St Joseph's School (Balclutha) (3826)" },
    { value: '3827', label: "St Joseph's Cathedral School (3827)" },
    { value: '3829', label: "St Leonard's School (Dunedin) (3829)" },
    { value: '3830', label: "St Mary's School (Dunedin) (3830)" },
    { value: '3831', label: "St Mary's School (Milton) (3831)" },
    { value: '3832', label: "St Mary's School (Mosgiel) (3832)" },
    { value: '3834', label: 'St Peter Chanel School (Green Island) (3834)' },
    { value: '3835', label: 'St Clair School (3835)' },
    { value: '3836', label: 'Stirling School (3836)' },
    { value: '3837', label: 'Strath Taieri School (3837)' },
    { value: '3839', label: 'Tahuna Normal Intermediate (3839)' },
    { value: '3840', label: 'Taieri Beach School (3840)' },
    { value: '3841', label: 'Tainui School (3841)' },
    { value: '3842', label: 'Tapanui School (3842)' },
    { value: '3843', label: 'Tarras School (3843)' },
    { value: '3844', label: 'The Terrace School (Alexandra) (3844)' },
    { value: '3845', label: 'Tokoiti School (3845)' },
    { value: '3847', label: 'Totara School (3847)' },
    { value: '3850', label: 'Waihola District School (3850)' },
    { value: '3851', label: 'Waikoikoi School (3851)' },
    { value: '3852', label: 'Waikouaiti School (3852)' },
    { value: '3855', label: 'Waitahuna School (3855)' },
    { value: '3857', label: 'Waitati School (3857)' },
    { value: '3858', label: 'Waiwera South School (3858)' },
    { value: '3859', label: 'Wakari School (3859)' },
    { value: '3861', label: 'Warepa School (3861)' },
    { value: '3862', label: 'Warrington School (3862)' },
    { value: '3864', label: 'Weston School (3864)' },
    { value: '3930', label: 'Arrowtown School (3930)' },
    { value: '3932', label: 'Balfour School (3932)' },
    { value: '3935', label: 'Hillside Primary School (3935)' },
    { value: '3938', label: 'Hauroko Valley Primary School (3938)' },
    { value: '3943', label: 'Dipton School (3943)' },
    { value: '3946', label: 'East Gore School (3946)' },
    { value: '3947', label: 'Edendale School (Southland) (3947)' },
    { value: '3953', label: 'Garston School (3953)' },
    { value: '3955', label: 'Glenorchy School (3955)' },
    { value: '3956', label: 'Gore Main School (3956)' },
    { value: '3957', label: 'Gorge Road School (3957)' },
    { value: '3961', label: 'Halfmoon Bay School (3961)' },
    { value: '3963', label: 'Heddon Bush School (3963)' },
    { value: '3964', label: 'Hedgehope School (3964)' },
    { value: '3966', label: 'Invercargill Middle School (3966)' },
    { value: '3967', label: 'Windsor North School (3967)' },
    { value: '3973', label: 'Knapdale School (3973)' },
    { value: '3975', label: 'Limehills School (3975)' },
    { value: '3977', label: 'Lochiel School (3977)' },
    { value: '3980', label: 'Lumsden School (3980)' },
    { value: '3982', label: 'Makarewa School (3982)' },
    { value: '3984', label: 'Mararoa School (3984)' },
    { value: '3986', label: 'Mataura School (3986)' },
    { value: '3990', label: 'Mossburn School (3990)' },
    { value: '3991', label: 'Myross Bush School (3991)' },
    { value: '3997', label: 'Otama School (3997)' },
    { value: '4000', label: 'Otatara School (4000)' },
    { value: '4001', label: 'Otautau School (4001)' },
    { value: '4003', label: 'Pukerau School (4003)' },
    { value: '4005', label: 'Queenstown Primary School (4005)' },
    { value: '4006', label: 'Rimu School (4006)' },
    { value: '4007', label: 'Riversdale School (4007)' },
    { value: '4008', label: 'Riverton School (4008)' },
    { value: '4011', label: 'Ruru Special School (4011)' },
    { value: '4013', label: 'Sacred Heart School (Waikiwi) (4013)' },
    { value: '4014', label: 'Salford School (4014)' },
    { value: '4016', label: "St Joseph's School (Queenstown) (4016)" },
    { value: '4017', label: "St Joseph's School (Invercargill) (4017)" },
    { value: '4018', label: "St Mary's School (Gore) (4018)" },
    { value: '4019', label: "St Patrick's School (Nightcaps) (4019)" },
    { value: '4020', label: "St Patrick's School (Invercargill) (4020)" },
    { value: '4021', label: "St Teresa's School (Bluff) (4021)" },
    { value: '4022', label: "St Theresa's School (Invercargill) (4022)" },
    { value: '4023', label: 'St Thomas School (Winton) (4023)' },
    { value: '4026', label: 'Te Anau School (4026)' },
    { value: '4027', label: 'Te Tipua School (4027)' },
    { value: '4028', label: 'Thornbury School (4028)' },
    { value: '4029', label: 'Tisbury School (4029)' },
    { value: '4030', label: 'Tokanui School (4030)' },
    { value: '4032', label: 'Tuturau Primary School (4032)' },
    { value: '4034', label: 'Waianiwa School (4034)' },
    { value: '4035', label: 'Waihopai School (4035)' },
    { value: '4036', label: 'Waikaia School (4036)' },
    { value: '4037', label: 'Waikaka School (4037)' },
    { value: '4046', label: 'Wallacetown School (4046)' },
    { value: '4047', label: 'Waverley Park School (4047)' },
    { value: '4050', label: 'West Gore School (4050)' },
    { value: '4052', label: 'Winton School (4052)' },
    { value: '4053', label: 'Woodlands Full Primary School (4053)' },
    { value: '4054', label: 'Wyndham School (4054)' },
    { value: '4100', label: 'Balmoral S D A School (4100)' },
    { value: '4101', label: 'Carncot Independent School (4101)' },
    { value: '4104', label: 'Hadlow Preparatory School (4104)' },
    { value: '4105', label: 'Hamilton Seventh-Day Adventist School (4105)' },
    { value: '4107', label: 'Parkside Christian S D A School (4107)' },
    { value: '4108', label: 'Hereworth School (4108)' },
    { value: '4109', label: 'Hōhepa School  (4109)' },
    { value: '4111', label: 'Huntley School (Marton) (4111)' },
    { value: '4112', label: 'Southland Adventist Christian School (4112)' },
    { value: '4116', label: "King's School (Remuera) (4116)" },
    { value: '4117', label: 'Liberton Christian School (4117)' },
    { value: '4118', label: 'Medbury Preparatory School (4118)' },
    { value: '4119', label: 'Wellington Hills Christian College (4119)' },
    { value: '4121', label: 'Nelson College For Girls Prep School (4121)' },
    { value: '4122', label: 'Nelson College (Prep Dept) (4122)' },
    { value: '4123', label: 'New Plymouth Adventist Christian School (4123)' },
    { value: '4125', label: 'Southcity Christian School (4125)' },
    {
      value: '4126',
      label: 'Palmerston North Adventist Christian School (4126)',
    },
    { value: '4129', label: 'Rotorua S D A School (4129)' },
    { value: '4130', label: "St George's School (4130)" },
    { value: '4131', label: "St John's Girls' School (Invercargill) (4131)" },
    { value: '4132', label: "St Joseph's School (Rangiora) (4132)" },
    { value: '4133', label: "Saint Kentigern Boys' School (4133)" },
    { value: '4134', label: "St Mark's Church School (Mt Victoria) (4134)" },
    { value: '4135', label: "St Mark's School (Christchurch) (4135)" },
    { value: '4136', label: "St Michael's Church School (4136)" },
    { value: '4138', label: 'Selwyn House School (4138)' },
    { value: '4140', label: 'South Auckland S D A School (4140)' },
    { value: '4141', label: 'Southwell School (4141)' },
    { value: '4143', label: 'Tamariki School (4143)' },
    { value: '4144', label: 'Tauranga Adventist School (4144)' },
    { value: '4145', label: "Te Pi'ipi'inga Kakano Mai I Rangiatea (4145)" },
    { value: '4146', label: 'Timatanga Community School (4146)' },
    { value: '4147', label: 'Waihi School (4147)' },
    { value: '4149', label: 'Wellesley College (4149)' },
    { value: '4150', label: 'Wellington S D A School (4150)' },
    { value: '4151', label: 'Waitakere S D A School (4151)' },
    { value: '4154', label: 'Whangarei Adventist Christian School (4154)' },
    {
      value: '4156',
      label: 'Blind and Low Vision Education Network NZ (4156)',
    },
    { value: '4157', label: 'Westbridge Residential School (4157)' },
    { value: '4158', label: "Hutt International Boys' School (4158)" },
    { value: '4160', label: 'TKKM o Te Atihaunui-A-Paparangi (4160)' },
    { value: '4204', label: 'Hare Krishna School (4204)' },
    {
      value: '4205',
      label: 'TKKM o Piripono Te Kura Whakahou ki Ōtara (4205)',
    },
    { value: '4207', label: 'TKKM o Nga Maungarongo (4207)' },
    { value: '4208', label: 'TKKM o Mangere (4208)' },
    { value: '4209', label: 'TKKM o Manawatu (4209)' },
    { value: '4211', label: 'TKKM o Te Rito (4211)' },
    { value: '4212', label: 'TKKM o Waitaha (4212)' },
    { value: '4217', label: 'Te Wharekura o Arowhenua (4217)' },
    { value: '4218', label: 'TKKM o Tokomaru (4218)' },
    { value: '4223', label: 'TKKM o Tamarongo (4223)' },
    { value: '4226', label: 'TKKM o Tamaki Nui A Rua (4226)' },
    { value: '4227', label: 'TKKM o Kaikohe (4227)' },
    { value: '4228', label: 'TKKM o Puau Te Moananui-a-Kiwa (4228)' },
    { value: '4229', label: 'TKKM o Manurewa (4229)' },
    { value: '4230', label: 'TKKM o Whakarewa I Te Reo Ki Tuwharetoa (4230)' },
    { value: '4535', label: 'Te Kura Kaupapa Māori o Hawaiki Hou (4535)' },
    { value: '4539', label: 'New Zealand IT College (4539)' },
    { value: '4541', label: 'The Forest School (4541)' },
    { value: '4543', label: 'Te Kapehu Whetu - Tamaki (4543)' },
    { value: '4545', label: 'Altum Academy (4545)' },
    { value: '4546', label: 'Aotearoa Infinite Academy (4546)' },
    { value: '4547', label: 'Te Aratika High School (4547)' },
    { value: '4548', label: 'Sisters United Academy (4548)' },
    { value: '4549', label: 'New Zealand Performance Academy Aotearoa (4549)' },
    { value: '6070', label: 'Golden Sands School (6070)' },
    { value: '6741', label: 'Te Matauranga (6741)' },
    { value: '6742', label: 'Tahatai Coast School (6742)' },
    { value: '6759', label: 'Snells Beach Primary School (6759)' },
    { value: '6760', label: 'Somerville Intermediate School (6760)' },
    { value: '6763', label: 'Whangaparaoa College (6763)' },
    { value: '6783', label: 'Remarkables Primary School (6783)' },
    { value: '6788', label: 'Hobsonville Point Primary School (6788)' },
    { value: '6920', label: 'Gulf Harbour School (6920)' },
    { value: '6921', label: 'Point View School (6921)' },
    { value: '6922', label: 'Waiheke Primary School (6922)' },
    { value: '6929', label: 'Alfriston College (6929)' },
    { value: '6930', label: 'Botany Downs Secondary College (6930)' },
    { value: '6932', label: 'Pinehill School (Browns Bay) (6932)' },
    { value: '6937', label: 'Summerland Primary (6937)' },
    { value: '6939', label: 'Kohia Terrace School (6939)' },
    { value: '6940', label: 'Te Akau ki Papamoa Primary School (6940)' },
    { value: '6941', label: 'Endeavour School (6941)' },
    { value: '6944', label: 'Randwick Park School (6944)' },
    { value: '6945', label: 'Selwyn Ridge School (6945)' },
    { value: '6946', label: 'Oteha Valley School (6946)' },
    { value: '6947', label: 'The Gardens School (6947)' },
    { value: '6948', label: 'Albany Junior High School (6948)' },
    { value: '6955', label: 'Upper Harbour Primary School (6955)' },
    { value: '6959', label: 'Willowbank School (Howick) (6959)' },
    { value: '6960', label: 'Baverstock Oaks School (6960)' },
    { value: '6962', label: 'Te Wharekura o Mauao (6962)' },
    { value: '6963', label: 'Papamoa College (6963)' },
    { value: '6967', label: 'Lemonwood Grove School (6967)' },
    { value: '6975', label: 'Garin College (6975)' },
    { value: '6976', label: 'Rototuna Primary School (6976)' },
    { value: '6977', label: 'Hobsonville Point Secondary School (6977)' },
    { value: '6978', label: 'Reremoana School (6978)' },
    { value: '6980', label: 'Clearview Primary (6980)' },
  ],
});
